// Auto-generated from Kitty terminal themes
// Sorted alphabetically, duplicates removed
// Updated: 2026-02-16T17:03:44.868Z

export const TERMINAL_THEMES = [
  {
    "id": "easy-invoice-theme",
    "name": "Easy Invoice",
    "isDark": false,
    "colors": {
      "background": "#ebe7e0",
      "surface": "#ffffff",
      "surfaceHover": "#f5f3ef",
      "surfaceElevated": "#ffffff",
      "text": "#1e3a6e",
      "textSecondary": "#3a6099",
      "textMuted": "#5a80b4",
      "primary": "#2656a8",
      "primaryHover": "#1e4a8f",
      "primaryLight": "#3a6bba",
      "primarySubtle": "#e0ddd6",
      "secondary": "#4a7ac4",
      "secondaryHover": "#3a6bba",
      "accent": "#c45d35",
      "accentHover": "#a84d2b",
      "success": "#2e7d5a",
      "border": "#ddd8cf",
      "borderSubtle": "#e8e4dc",
      "shadow": "rgba(38, 86, 168, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ebe7e0",
      "#2656a8",
      "#c45d35",
      "#2e7d5a",
      "#4a7ac4",
      "#1e4a8f"
    ]
  },
  {
    "id": "easy-invoice-dark",
    "name": "Easy Invoice Dark",
    "isDark": true,
    "colors": {
      "background": "#1a1c22",
      "surface": "#22252e",
      "surfaceHover": "#2a2d38",
      "surfaceElevated": "#2e3140",
      "text": "#e8ecf4",
      "textSecondary": "#8a9bbd",
      "textMuted": "#7085a8",
      "primary": "#5b8dd9",
      "primaryHover": "#4a7ac4",
      "primaryLight": "#6e9de3",
      "primarySubtle": "#2a2d38",
      "secondary": "#6e9de3",
      "secondaryHover": "#5b8dd9",
      "accent": "#e07050",
      "accentHover": "#c45d35",
      "success": "#4a9d72",
      "border": "#33384a",
      "borderSubtle": "#2a2d38",
      "shadow": "rgba(0, 0, 0, 0.5)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1a1c22",
      "#e8ecf4",
      "#e07050",
      "#4a9d72",
      "#5b8dd9",
      "#8a9bbd"
    ]
  },
  {
    "name": "1984 light",
    "isDark": false,
    "colors": {
      "background": "#e4e5f5",
      "surface": "#dcdded",
      "surfaceHover": "#d0d1e1",
      "surfaceElevated": "#dfe0f0",
      "text": "#19152c",
      "textSecondary": "#000000",
      "textMuted": "#08060d",
      "primary": "#007de2",
      "primaryHover": "#0072d7",
      "primaryLight": "#4de5ff",
      "primarySubtle": "#d7d8e8",
      "secondary": "#00b2be",
      "secondaryHover": "#008c98",
      "accent": "#ff16b0",
      "accentHover": "#d9008a",
      "success": "#00af4f",
      "border": "#bebfcf",
      "borderSubtle": "#d0d1e1",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#e4e5f5",
      "#19152c",
      "#ff16b0",
      "#00af4f",
      "#ff8d01",
      "#0098fd",
      "#00b2be",
      "#000000"
    ],
    "id": "1984-light"
  },
  {
    "name": "3024 Day",
    "isDark": false,
    "colors": {
      "background": "#f7f7f7",
      "surface": "#efefef",
      "surfaceHover": "#e3e3e3",
      "surfaceElevated": "#f2f2f2",
      "text": "#494542",
      "textSecondary": "#5b5754",
      "textMuted": "#56524f",
      "primary": "#0091d5",
      "primaryHover": "#007abe",
      "primaryLight": "#4dedff",
      "primarySubtle": "#eaeaea",
      "secondary": "#b5e4f4",
      "secondaryHover": "#8fbece",
      "accent": "#da2c20",
      "accentHover": "#b40600",
      "success": "#00a152",
      "border": "#d1d1d1",
      "borderSubtle": "#e3e3e3",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f7f7f7",
      "#494542",
      "#da2c20",
      "#00a152",
      "#fcec02",
      "#00a0e4",
      "#b5e4f4",
      "#5b5754"
    ],
    "id": "3024-day"
  },
  {
    "name": "3024 Night",
    "isDark": true,
    "colors": {
      "background": "#090200",
      "surface": "#1d1614",
      "surfaceHover": "#322b29",
      "surfaceElevated": "#28211f",
      "text": "#a4a1a1",
      "textSecondary": "#85817e",
      "textMuted": "#7a7674",
      "primary": "#00a0e4",
      "primaryHover": "#7f7c7b",
      "primaryLight": "#33d3ff",
      "primarySubtle": "#28211f",
      "secondary": "#b5e4f4",
      "secondaryHover": "#ccab53",
      "accent": "#da2c20",
      "accentHover": "#e8bacf",
      "success": "#00a152",
      "border": "#494240",
      "borderSubtle": "#2f2826",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#090200",
      "#a4a1a1",
      "#da2c20",
      "#00a152",
      "#fcec02",
      "#00a0e4",
      "#b5e4f4",
      "#5b5754"
    ],
    "id": "3024-night"
  },
  {
    "name": "Adwaita dark",
    "isDark": true,
    "colors": {
      "background": "#1d1d20",
      "surface": "#313134",
      "surfaceHover": "#464649",
      "surfaceElevated": "#3c3c3f",
      "text": "#deddda",
      "textSecondary": "#9a9996",
      "textMuted": "#aeadaa",
      "primary": "#62a0ea",
      "primaryHover": "#99c1f1",
      "primaryLight": "#95d3ff",
      "primarySubtle": "#3c3c3f",
      "secondary": "#5bc8af",
      "secondaryHover": "#93ddc2",
      "accent": "#ed333b",
      "accentHover": "#f66151",
      "success": "#57e389",
      "border": "#5d5d60",
      "borderSubtle": "#434346",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1d1d20",
      "#deddda",
      "#ed333b",
      "#57e389",
      "#ff7800",
      "#62a0ea",
      "#5bc8af",
      "#9a9996"
    ],
    "id": "adwaita-dark"
  },
  {
    "name": "Adwaita darker",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#deddda",
      "textSecondary": "#9a9996",
      "textMuted": "#aeadaa",
      "primary": "#62a0ea",
      "primaryHover": "#99c1f1",
      "primaryLight": "#95d3ff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#5bc8af",
      "secondaryHover": "#93ddc2",
      "accent": "#ed333b",
      "accentHover": "#f66151",
      "success": "#57e389",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#deddda",
      "#ed333b",
      "#57e389",
      "#ff7800",
      "#62a0ea",
      "#5bc8af",
      "#9a9996"
    ],
    "id": "adwaita-darker"
  },
  {
    "name": "Alabaster",
    "isDark": false,
    "colors": {
      "background": "#f7f7f7",
      "surface": "#efefef",
      "surfaceHover": "#e3e3e3",
      "surfaceElevated": "#f2f2f2",
      "text": "#000000",
      "textSecondary": "#6b6b6b",
      "textMuted": "#535353",
      "primary": "#325cc0",
      "primaryHover": "#0c369a",
      "primaryLight": "#7fa9ff",
      "primarySubtle": "#eaeaea",
      "secondary": "#0083b2",
      "secondaryHover": "#005d8c",
      "accent": "#aa3731",
      "accentHover": "#84110b",
      "success": "#448c37",
      "border": "#d1d1d1",
      "borderSubtle": "#e3e3e3",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f7f7f7",
      "#000000",
      "#aa3731",
      "#448c37",
      "#cb9000",
      "#325cc0",
      "#0083b2",
      "#777777"
    ],
    "id": "alabaster"
  },
  {
    "name": "Alabaster Dark",
    "isDark": true,
    "colors": {
      "background": "#0e1415",
      "surface": "#222829",
      "surfaceHover": "#373d3e",
      "surfaceElevated": "#2d3334",
      "text": "#cecece",
      "textSecondary": "#8f8f8f",
      "textMuted": "#919191",
      "primary": "#4a88e4",
      "primaryHover": "#6f8fdb",
      "primaryLight": "#7dbbff",
      "primarySubtle": "#2d3334",
      "secondary": "#23acdd",
      "secondaryHover": "#4ac9e2",
      "accent": "#e25d56",
      "accentHover": "#f36868",
      "success": "#73ca50",
      "border": "#4e5455",
      "borderSubtle": "#343a3b",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0e1415",
      "#cecece",
      "#e25d56",
      "#73ca50",
      "#e9bf57",
      "#4a88e4",
      "#23acdd",
      "#777777"
    ],
    "id": "alabaster-dark"
  },
  {
    "name": "Alucard",
    "isDark": true,
    "colors": {
      "background": "#222330",
      "surface": "#363744",
      "surfaceHover": "#4b4c59",
      "surfaceElevated": "#41424f",
      "text": "#cef3ff",
      "textSecondary": "#a2a2a2",
      "textMuted": "#919c9f",
      "primary": "#3282ff",
      "primaryHover": "#1200f8",
      "primaryLight": "#65b5ff",
      "primarySubtle": "#41424f",
      "secondary": "#0037fc",
      "secondaryHover": "#8ae9fc",
      "accent": "#ff5555",
      "accentHover": "#ff5454",
      "success": "#fa0074",
      "border": "#626370",
      "borderSubtle": "#484956",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#222330",
      "#cef3ff",
      "#ff5555",
      "#fa0074",
      "#7f0a1f",
      "#3282ff",
      "#0037fc",
      "#545454"
    ],
    "id": "alucard"
  },
  {
    "name": "Argonaut",
    "isDark": true,
    "colors": {
      "background": "#0d0f18",
      "surface": "#21232c",
      "surfaceHover": "#363841",
      "surfaceElevated": "#2c2e37",
      "text": "#fffaf3",
      "textSecondary": "#8c8c8c",
      "textMuted": "#858481",
      "primary": "#008df8",
      "primaryHover": "#0092ff",
      "primaryLight": "#33c0ff",
      "primarySubtle": "#2c2e37",
      "secondary": "#00d7eb",
      "secondaryHover": "#67ffef",
      "accent": "#ff000f",
      "accentHover": "#ff273f",
      "success": "#8ce00a",
      "border": "#4d4f58",
      "borderSubtle": "#33353e",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0d0f18",
      "#fffaf3",
      "#ff000f",
      "#8ce00a",
      "#ffb900",
      "#008df8",
      "#00d7eb",
      "#444444"
    ],
    "id": "argonaut"
  },
  {
    "name": "Atom One Light",
    "isDark": false,
    "colors": {
      "background": "#f8f8f8",
      "surface": "#f0f0f0",
      "surfaceHover": "#e4e4e4",
      "surfaceElevated": "#f3f3f3",
      "text": "#2a2b33",
      "textSecondary": "#000000",
      "textMuted": "#0d0d0f",
      "primary": "#2f5af3",
      "primaryHover": "#0934cd",
      "primaryLight": "#7ca7ff",
      "primarySubtle": "#ebebeb",
      "secondary": "#3e953a",
      "secondaryHover": "#186f14",
      "accent": "#de3d35",
      "accentHover": "#b8170f",
      "success": "#3e953a",
      "border": "#d2d2d2",
      "borderSubtle": "#e4e4e4",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f8f8f8",
      "#2a2b33",
      "#de3d35",
      "#3e953a",
      "#d2b67b",
      "#2f5af3",
      "#3e953a",
      "#000000"
    ],
    "id": "atom-one-light"
  },
  {
    "name": "Ayaka",
    "isDark": true,
    "colors": {
      "background": "#36283d",
      "surface": "#4a3c51",
      "surfaceHover": "#5f5166",
      "surfaceElevated": "#55475c",
      "text": "#cedaeb",
      "textSecondary": "#a5adb9",
      "textMuted": "#a3acb9",
      "primary": "#9ea0d3",
      "primaryHover": "#9ea0d3",
      "primaryLight": "#d1d3ff",
      "primarySubtle": "#55475c",
      "secondary": "#e1b4ce",
      "secondaryHover": "#e1b4ce",
      "accent": "#71ade9",
      "accentHover": "#71ade9",
      "success": "#ab8cae",
      "border": "#76687d",
      "borderSubtle": "#5c4e63",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#36283d",
      "#cedaeb",
      "#71ade9",
      "#ab8cae",
      "#e59db1",
      "#9ea0d3",
      "#e1b4ce",
      "#9098a4"
    ],
    "id": "ayaka"
  },
  {
    "name": "ayu light",
    "isDark": false,
    "colors": {
      "background": "#fafafa",
      "surface": "#f2f2f2",
      "surfaceHover": "#e6e6e6",
      "surfaceElevated": "#f5f5f5",
      "text": "#5b6673",
      "textSecondary": "#323232",
      "textMuted": "#3e4246",
      "primary": "#2f94c7",
      "primaryHover": "#1b80b3",
      "primaryLight": "#8ef3ff",
      "primarySubtle": "#ededed",
      "secondary": "#4cbe99",
      "secondaryHover": "#269873",
      "accent": "#ff3333",
      "accentHover": "#d90d0d",
      "success": "#86b200",
      "border": "#d4d4d4",
      "borderSubtle": "#e6e6e6",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#fafafa",
      "#5b6673",
      "#ff3333",
      "#86b200",
      "#f19618",
      "#41a6d9",
      "#4cbe99",
      "#323232"
    ],
    "id": "ayu-light"
  },
  {
    "name": "ayu mirage",
    "isDark": true,
    "colors": {
      "background": "#212733",
      "surface": "#353b47",
      "surfaceHover": "#4a505c",
      "surfaceElevated": "#404652",
      "text": "#d9d7ce",
      "textSecondary": "#a4a4a4",
      "textMuted": "#9f9e9c",
      "primary": "#6dcbfa",
      "primaryHover": "#73d0ff",
      "primaryLight": "#a0feff",
      "primarySubtle": "#404652",
      "secondary": "#90e1c6",
      "secondaryHover": "#95e6cb",
      "accent": "#ed8274",
      "accentHover": "#f28779",
      "success": "#a6cc70",
      "border": "#616773",
      "borderSubtle": "#474d59",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#212733",
      "#d9d7ce",
      "#ed8274",
      "#a6cc70",
      "#fad07b",
      "#6dcbfa",
      "#90e1c6",
      "#686868"
    ],
    "id": "ayu-mirage"
  },
  {
    "name": "Belafonte Day",
    "isDark": false,
    "colors": {
      "background": "#d4ccb9",
      "surface": "#ccc4b1",
      "surfaceHover": "#c0b8a5",
      "surfaceElevated": "#cfc7b4",
      "text": "#45363b",
      "textSecondary": "#5b4f4f",
      "textMuted": "#574a4b",
      "primary": "#416978",
      "primaryHover": "#1b4352",
      "primaryLight": "#8eb6c5",
      "primarySubtle": "#c7bfac",
      "secondary": "#98999c",
      "secondaryHover": "#727376",
      "accent": "#bd100d",
      "accentHover": "#970000",
      "success": "#858062",
      "border": "#aea693",
      "borderSubtle": "#c0b8a5",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#d4ccb9",
      "#45363b",
      "#bd100d",
      "#858062",
      "#e9a448",
      "#416978",
      "#98999c",
      "#5e5252"
    ],
    "id": "belafonte-day"
  },
  {
    "name": "Bifrost",
    "isDark": true,
    "colors": {
      "background": "#101010",
      "surface": "#242424",
      "surfaceHover": "#393939",
      "surfaceElevated": "#2f2f2f",
      "text": "#d2d2d2",
      "textSecondary": "#8d8d8d",
      "textMuted": "#828282",
      "primary": "#02a2ff",
      "primaryHover": "#71cbff",
      "primaryLight": "#35d5ff",
      "primarySubtle": "#2f2f2f",
      "secondary": "#3da698",
      "secondaryHover": "#9cf0ed",
      "accent": "#f03669",
      "accentHover": "#c75b79",
      "success": "#b8e346",
      "border": "#505050",
      "borderSubtle": "#363636",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#101010",
      "#d2d2d2",
      "#f03669",
      "#b8e346",
      "#ffa402",
      "#02a2ff",
      "#3da698",
      "#606060"
    ],
    "id": "bifrost"
  },
  {
    "name": "BirdsOfParadise",
    "isDark": true,
    "colors": {
      "background": "#2a1e1d",
      "surface": "#3e3231",
      "surfaceHover": "#534746",
      "surfaceElevated": "#493d3c",
      "text": "#dfdab7",
      "textSecondary": "#c49573",
      "textMuted": "#b59270",
      "primary": "#5a86ac",
      "primaryHover": "#b8d3ed",
      "primaryLight": "#8db9df",
      "primarySubtle": "#493d3c",
      "secondary": "#74a5ac",
      "secondaryHover": "#92ced6",
      "accent": "#be2d26",
      "accentHover": "#e84526",
      "success": "#6ba08a",
      "border": "#6a5e5d",
      "borderSubtle": "#504443",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#2a1e1d",
      "#dfdab7",
      "#be2d26",
      "#6ba08a",
      "#e99c29",
      "#5a86ac",
      "#74a5ac",
      "#9a6b49"
    ],
    "id": "birdsofparadise"
  },
  {
    "name": "BlackMetal",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#ffffff",
      "textSecondary": "#7e7e7e",
      "textMuted": "#737373",
      "primary": "#888888",
      "primaryHover": "#888888",
      "primaryLight": "#bbbbbb",
      "primarySubtle": "#1f1f1f",
      "secondary": "#aaaaaa",
      "secondaryHover": "#aaaaaa",
      "accent": "#5f8787",
      "accentHover": "#5f8787",
      "success": "#dd9999",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#ffffff",
      "#5f8787",
      "#dd9999",
      "#a06666",
      "#888888",
      "#aaaaaa",
      "#333333"
    ],
    "id": "blackmetal"
  },
  {
    "name": "Bliss",
    "isDark": true,
    "colors": {
      "background": "#16181f",
      "surface": "#2a2c33",
      "surfaceHover": "#3f4148",
      "surfaceElevated": "#35373e",
      "text": "#eaeaea",
      "textSecondary": "#949494",
      "textMuted": "#8e8e8e",
      "primary": "#a198ff",
      "primaryHover": "#aea6ff",
      "primaryLight": "#d4cbff",
      "primarySubtle": "#35373e",
      "secondary": "#95dfff",
      "secondaryHover": "#a5def7",
      "accent": "#ff6f8d",
      "accentHover": "#ff7894",
      "success": "#93ff8d",
      "border": "#56585f",
      "borderSubtle": "#3c3e45",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#16181f",
      "#eaeaea",
      "#ff6f8d",
      "#93ff8d",
      "#fffc9b",
      "#a198ff",
      "#95dfff",
      "#676767"
    ],
    "id": "bliss"
  },
  {
    "name": "Blueberry Mango",
    "isDark": true,
    "colors": {
      "background": "#181321",
      "surface": "#2c2735",
      "surfaceHover": "#413c4a",
      "surfaceElevated": "#373240",
      "text": "#feffe0",
      "textSecondary": "#8c92a2",
      "textMuted": "#868b8c",
      "primary": "#6ee4de",
      "primaryHover": "#abfcf3",
      "primaryLight": "#a1ffff",
      "primarySubtle": "#373240",
      "secondary": "#6fb3bf",
      "secondaryHover": "#c7f1fc",
      "accent": "#ed7481",
      "accentHover": "#f0a2a3",
      "success": "#54b99d",
      "border": "#585361",
      "borderSubtle": "#3e3947",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#181321",
      "#feffe0",
      "#ed7481",
      "#54b99d",
      "#e0c750",
      "#6ee4de",
      "#6fb3bf",
      "#4a5060"
    ],
    "id": "blueberry-mango"
  },
  {
    "name": "Bluloco Dark",
    "isDark": true,
    "colors": {
      "background": "#282c34",
      "surface": "#3c4048",
      "surfaceHover": "#51555d",
      "surfaceElevated": "#474b53",
      "text": "#c5ccd7",
      "textSecondary": "#a1acc0",
      "textMuted": "#9ca5b7",
      "primary": "#4688ff",
      "primaryHover": "#10b1fe",
      "primaryLight": "#67a9ff",
      "primarySubtle": "#474b53",
      "secondary": "#4483aa",
      "secondaryHover": "#5fb9bc",
      "accent": "#fc2f52",
      "accentHover": "#ff6480",
      "success": "#25a45c",
      "border": "#686c74",
      "borderSubtle": "#4e525a",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#282c34",
      "#b9c0cb",
      "#fc2f52",
      "#25a45c",
      "#ff936a",
      "#3476ff",
      "#4483aa",
      "#8f9aae"
    ],
    "id": "blulocodark"
  },
  {
    "name": "Bluloco Light",
    "isDark": false,
    "colors": {
      "background": "#f9f9f9",
      "surface": "#f1f1f1",
      "surfaceHover": "#e5e5e5",
      "surfaceElevated": "#f4f4f4",
      "text": "#373a41",
      "textSecondary": "#676a77",
      "textMuted": "#595c67",
      "primary": "#275fe4",
      "primaryHover": "#0139be",
      "primaryLight": "#74acff",
      "primarySubtle": "#ececec",
      "secondary": "#27618d",
      "secondaryHover": "#013b67",
      "accent": "#d52753",
      "accentHover": "#af012d",
      "success": "#23974a",
      "border": "#d3d3d3",
      "borderSubtle": "#e5e5e5",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f9f9f9",
      "#373a41",
      "#d52753",
      "#23974a",
      "#df631c",
      "#275fe4",
      "#27618d",
      "#676a77"
    ],
    "id": "blulocolight"
  },
  {
    "name": "Borland",
    "isDark": true,
    "colors": {
      "background": "#0000a3",
      "surface": "#1414b7",
      "surfaceHover": "#2929cc",
      "surfaceElevated": "#1f1fc2",
      "text": "#ffff4d",
      "textSecondary": "#a3a3a3",
      "textMuted": "#a3a36e",
      "primary": "#96cafd",
      "primaryHover": "#b5dcfe",
      "primaryLight": "#c9fdff",
      "primarySubtle": "#1f1fc2",
      "secondary": "#c6c4fd",
      "secondaryHover": "#dfdffe",
      "accent": "#ff6b60",
      "accentHover": "#ffb6b0",
      "success": "#a7ff60",
      "border": "#4040e3",
      "borderSubtle": "#2626c9",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0000a3",
      "#ffff4d",
      "#ff6b60",
      "#a7ff60",
      "#ffffb6",
      "#96cafd",
      "#c6c4fd",
      "#7c7c7c"
    ],
    "id": "borland"
  },
  {
    "name": "Box",
    "isDark": true,
    "colors": {
      "background": "#141d2b",
      "surface": "#28313f",
      "surfaceHover": "#3d4654",
      "surfaceElevated": "#333c4a",
      "text": "#9fef00",
      "textSecondary": "#9a9a9a",
      "textMuted": "#829a53",
      "primary": "#167cd5",
      "primaryHover": "#1a8fff",
      "primaryLight": "#40a6ff",
      "primarySubtle": "#333c4a",
      "secondary": "#0dcdcd",
      "secondaryHover": "#14ffff",
      "accent": "#cc0403",
      "accentHover": "#f2201f",
      "success": "#19cb00",
      "border": "#545d6b",
      "borderSubtle": "#3a4351",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#141d2b",
      "#9fef00",
      "#cc0403",
      "#19cb00",
      "#cecb00",
      "#0d73cc",
      "#0dcdcd",
      "#767676"
    ],
    "id": "box"
  },
  {
    "name": "Brogrammer",
    "isDark": true,
    "colors": {
      "background": "#131313",
      "surface": "#272727",
      "surfaceHover": "#3c3c3c",
      "surfaceElevated": "#323232",
      "text": "#d6dae4",
      "textSecondary": "#d6dae4",
      "textMuted": "#d6dae4",
      "primary": "#2a84d2",
      "primaryHover": "#0f80d5",
      "primaryLight": "#5db7ff",
      "primarySubtle": "#323232",
      "secondary": "#0f80d5",
      "secondaryHover": "#0f7cda",
      "accent": "#f71118",
      "accentHover": "#de342e",
      "success": "#2cc55d",
      "border": "#535353",
      "borderSubtle": "#393939",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#131313",
      "#d6dae4",
      "#f71118",
      "#2cc55d",
      "#ecb90f",
      "#2a84d2",
      "#0f80d5",
      "#d6dae4"
    ],
    "id": "brogrammer"
  },
  {
    "name": "Carbonfox",
    "isDark": true,
    "colors": {
      "background": "#161616",
      "surface": "#2a2a2a",
      "surfaceHover": "#3f3f3f",
      "surfaceElevated": "#353535",
      "text": "#f2f4f8",
      "textSecondary": "#939393",
      "textMuted": "#8a8b8c",
      "primary": "#78a9ff",
      "primaryHover": "#8cb6ff",
      "primaryLight": "#abdcff",
      "primarySubtle": "#353535",
      "secondary": "#33b1ff",
      "secondaryHover": "#52bdff",
      "accent": "#ee5396",
      "accentHover": "#f16da6",
      "success": "#25be6a",
      "border": "#565656",
      "borderSubtle": "#3c3c3c",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#161616",
      "#f2f4f8",
      "#ee5396",
      "#25be6a",
      "#ebcb8b",
      "#78a9ff",
      "#33b1ff",
      "#484848"
    ],
    "id": "carbonfox"
  },
  {
    "name": "Catppuccin-Latte",
    "isDark": false,
    "colors": {
      "background": "#eff1f5",
      "surface": "#e7e9ed",
      "surfaceHover": "#dbdde1",
      "surfaceElevated": "#eaecf0",
      "text": "#4c4f69",
      "textSecondary": "#63667c",
      "textMuted": "#62657d",
      "primary": "#1e66f5",
      "primaryHover": "#0040cf",
      "primaryLight": "#6bb3ff",
      "primarySubtle": "#e2e4e8",
      "secondary": "#179299",
      "secondaryHover": "#006c73",
      "accent": "#d20f39",
      "accentHover": "#ac0013",
      "success": "#40a02b",
      "border": "#c9cbcf",
      "borderSubtle": "#dbdde1",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#eff1f5",
      "#4c4f69",
      "#d20f39",
      "#40a02b",
      "#df8e1d",
      "#1e66f5",
      "#179299",
      "#6c6f85"
    ],
    "id": "catppuccin-latte"
  },
  {
    "name": "Catppuccin-Mocha",
    "isDark": true,
    "colors": {
      "background": "#1e1e2e",
      "surface": "#323242",
      "surfaceHover": "#474757",
      "surfaceElevated": "#3d3d4d",
      "text": "#cdd6f4",
      "textSecondary": "#979aaf",
      "textMuted": "#9095ad",
      "primary": "#89b4fa",
      "primaryHover": "#89b4fa",
      "primaryLight": "#bce7ff",
      "primarySubtle": "#3d3d4d",
      "secondary": "#94e2d5",
      "secondaryHover": "#94e2d5",
      "accent": "#f38ba8",
      "accentHover": "#f38ba8",
      "success": "#a6e3a1",
      "border": "#5e5e6e",
      "borderSubtle": "#444454",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1e1e2e",
      "#cdd6f4",
      "#f38ba8",
      "#a6e3a1",
      "#f9e2af",
      "#89b4fa",
      "#94e2d5",
      "#585b70"
    ],
    "id": "catppuccin-mocha"
  },
  {
    "name": "Chalice",
    "isDark": false,
    "colors": {
      "background": "#f0eff0",
      "surface": "#e8e7e8",
      "surfaceHover": "#dcdbdc",
      "surfaceElevated": "#ebeaeb",
      "text": "#000000",
      "textSecondary": "#686768",
      "textMuted": "#535353",
      "primary": "#3c5aba",
      "primaryHover": "#163494",
      "primaryLight": "#89a7ff",
      "primarySubtle": "#e3e2e3",
      "secondary": "#4ba7c7",
      "secondaryHover": "#2581a1",
      "accent": "#9d3f36",
      "accentHover": "#771910",
      "success": "#568a36",
      "border": "#cac9ca",
      "borderSubtle": "#dcdbdc",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f0eff0",
      "#000000",
      "#9d3f36",
      "#568a36",
      "#cc984a",
      "#3c5aba",
      "#4ba7c7",
      "#777677"
    ],
    "id": "chalice"
  },
  {
    "name": "Chalice Dark",
    "isDark": true,
    "colors": {
      "background": "#0e1315",
      "surface": "#222729",
      "surfaceHover": "#373c3e",
      "surfaceElevated": "#2d3234",
      "text": "#8daeb2",
      "textSecondary": "#8f8e8f",
      "textMuted": "#7e8789",
      "primary": "#0b81b2",
      "primaryHover": "#109ed9",
      "primaryLight": "#3eb4e5",
      "primarySubtle": "#2d3234",
      "secondary": "#72abe7",
      "secondaryHover": "#94beed",
      "accent": "#c6423a",
      "accentHover": "#d36e68",
      "success": "#94cc81",
      "border": "#4e5355",
      "borderSubtle": "#34393b",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0e1315",
      "#8daeb2",
      "#c6423a",
      "#94cc81",
      "#cc984a",
      "#0b81b2",
      "#72abe7",
      "#777677"
    ],
    "id": "chalice-dark"
  },
  {
    "name": "CLRS",
    "isDark": false,
    "colors": {
      "background": "#ffffff",
      "surface": "#f7f7f7",
      "surfaceHover": "#ebebeb",
      "surfaceElevated": "#fafafa",
      "text": "#262626",
      "textSecondary": "#545753",
      "textMuted": "#464846",
      "primary": "#125ccf",
      "primaryHover": "#0036a9",
      "primaryLight": "#5fa9ff",
      "primarySubtle": "#f2f2f2",
      "secondary": "#32c2c0",
      "secondaryHover": "#0c9c9a",
      "accent": "#f72729",
      "accentHover": "#d10103",
      "success": "#32895c",
      "border": "#d9d9d9",
      "borderSubtle": "#ebebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ffffff",
      "#262626",
      "#f72729",
      "#32895c",
      "#f96f1c",
      "#125ccf",
      "#32c2c0",
      "#545753"
    ],
    "id": "clrs"
  },
  {
    "name": "Cobalt Neon",
    "isDark": true,
    "colors": {
      "background": "#142838",
      "surface": "#283c4c",
      "surfaceHover": "#3d5161",
      "surfaceElevated": "#334757",
      "text": "#8ff586",
      "textSecondary": "#fff688",
      "textMuted": "#ddf687",
      "primary": "#8ff586",
      "primaryHover": "#3c7dd2",
      "primaryLight": "#c2ffb9",
      "primarySubtle": "#334757",
      "secondary": "#8ff586",
      "secondaryHover": "#6cbc67",
      "accent": "#ff2320",
      "accentHover": "#d4312e",
      "success": "#3aa5ff",
      "border": "#546878",
      "borderSubtle": "#3a4e5e",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#142838",
      "#8ff586",
      "#ff2320",
      "#3aa5ff",
      "#e9e75c",
      "#8ff586",
      "#8ff586",
      "#fff688"
    ],
    "id": "cobalt-neon"
  },
  {
    "name": "Cobalt2",
    "isDark": true,
    "colors": {
      "background": "#193549",
      "surface": "#2d495d",
      "surfaceHover": "#425e72",
      "surfaceElevated": "#385468",
      "text": "#ffffff",
      "textSecondary": "#b3b3b3",
      "textMuted": "#bbbbbb",
      "primary": "#00aaff",
      "primaryHover": "#0050a4",
      "primaryLight": "#33ddff",
      "primarySubtle": "#385468",
      "secondary": "#80fcff",
      "secondaryHover": "#8fbfdc",
      "accent": "#ff0000",
      "accentHover": "#700009",
      "success": "#3ad900",
      "border": "#597589",
      "borderSubtle": "#3f5b6f",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#193549",
      "#ffffff",
      "#ff0000",
      "#3ad900",
      "#ffc600",
      "#00aaff",
      "#80fcff",
      "#9e9e9e"
    ],
    "id": "cobalt2"
  },
  {
    "name": "Dainty Dark",
    "isDark": true,
    "colors": {
      "background": "#011423",
      "surface": "#152837",
      "surfaceHover": "#2a3d4c",
      "surfaceElevated": "#203342",
      "text": "#cbe0f0",
      "textSecondary": "#6991b1",
      "textMuted": "#6688a4",
      "primary": "#0fc5ed",
      "primaryHover": "#a277ff",
      "primaryLight": "#42f8ff",
      "primarySubtle": "#203342",
      "secondary": "#24eaf7",
      "secondaryHover": "#24eaf7",
      "accent": "#e52e2e",
      "accentHover": "#e52e2e",
      "success": "#44ffb1",
      "border": "#415463",
      "borderSubtle": "#273a49",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#011423",
      "#cbe0f0",
      "#e52e2e",
      "#44ffb1",
      "#ffe073",
      "#0fc5ed",
      "#24eaf7",
      "#214969"
    ],
    "id": "daintydark"
  },
  {
    "name": "Dark Pastel",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#ffffff",
      "textSecondary": "#7e7e7e",
      "textMuted": "#878787",
      "primary": "#5555ff",
      "primaryHover": "#5555ff",
      "primaryLight": "#8888ff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#55ffff",
      "secondaryHover": "#55ffff",
      "accent": "#ff5555",
      "accentHover": "#ff5555",
      "success": "#55ff55",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#ffffff",
      "#ff5555",
      "#55ff55",
      "#ffff55",
      "#5555ff",
      "#55ffff",
      "#545454"
    ],
    "id": "dark-pastel"
  },
  {
    "name": "Dawnfox",
    "isDark": false,
    "colors": {
      "background": "#faf4ed",
      "surface": "#f2ece5",
      "surfaceHover": "#e6e0d9",
      "surfaceElevated": "#f5efe8",
      "text": "#575279",
      "textSecondary": "#5f5695",
      "textMuted": "#5d558d",
      "primary": "#286983",
      "primaryHover": "#02435d",
      "primaryLight": "#75b6d0",
      "primarySubtle": "#ede7e0",
      "secondary": "#56949f",
      "secondaryHover": "#306e79",
      "accent": "#b4637a",
      "accentHover": "#8e3d54",
      "success": "#618774",
      "border": "#d4cec7",
      "borderSubtle": "#e6e0d9",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#faf4ed",
      "#575279",
      "#b4637a",
      "#618774",
      "#ea9d34",
      "#286983",
      "#56949f",
      "#5f5695"
    ],
    "id": "dawnfox"
  },
  {
    "name": "Dayfox",
    "isDark": false,
    "colors": {
      "background": "#f6f2ee",
      "surface": "#eeeae6",
      "surfaceHover": "#e2deda",
      "surfaceElevated": "#f1ede9",
      "text": "#3d2b5a",
      "textSecondary": "#534c45",
      "textMuted": "#4c424b",
      "primary": "#286983",
      "primaryHover": "#02435d",
      "primaryLight": "#75b6d0",
      "primarySubtle": "#e9e5e1",
      "secondary": "#287980",
      "secondaryHover": "#02535a",
      "accent": "#a5222f",
      "accentHover": "#7f0009",
      "success": "#396847",
      "border": "#d0ccc8",
      "borderSubtle": "#e2deda",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f6f2ee",
      "#3d2b5a",
      "#a5222f",
      "#396847",
      "#ac5402",
      "#286983",
      "#287980",
      "#534c45"
    ],
    "id": "dayfox"
  },
  {
    "name": "DimmedMonokai",
    "isDark": true,
    "colors": {
      "background": "#1e1e1e",
      "surface": "#323232",
      "surfaceHover": "#474747",
      "surfaceElevated": "#3d3d3d",
      "text": "#b8bcb9",
      "textSecondary": "#9a9b99",
      "textMuted": "#969896",
      "primary": "#577faa",
      "primaryHover": "#176ce3",
      "primaryLight": "#81a9d4",
      "primarySubtle": "#3d3d3d",
      "secondary": "#568ea3",
      "secondaryHover": "#2d6f6c",
      "accent": "#be3e48",
      "accentHover": "#fb001e",
      "success": "#869a3a",
      "border": "#5e5e5e",
      "borderSubtle": "#444444",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1e1e1e",
      "#b8bcb9",
      "#be3e48",
      "#869a3a",
      "#c4a535",
      "#4e76a1",
      "#568ea3",
      "#888987"
    ],
    "id": "dimmedmonokai"
  },
  {
    "name": "Dracula",
    "isDark": true,
    "colors": {
      "background": "#282a36",
      "surface": "#3c3e4a",
      "surfaceHover": "#51535f",
      "surfaceElevated": "#474955",
      "text": "#f8f8f2",
      "textSecondary": "#98a8da",
      "textMuted": "#98a3c4",
      "primary": "#bd93f9",
      "primaryHover": "#d6acff",
      "primaryLight": "#f0c6ff",
      "primarySubtle": "#474955",
      "secondary": "#8be9fd",
      "secondaryHover": "#a4ffff",
      "accent": "#ff5555",
      "accentHover": "#ff6e6e",
      "success": "#50fa7b",
      "border": "#686a76",
      "borderSubtle": "#4e505c",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#282a36",
      "#f8f8f2",
      "#ff5555",
      "#50fa7b",
      "#f1fa8c",
      "#bd93f9",
      "#8be9fd",
      "#6272a4"
    ],
    "id": "dracula"
  },
  {
    "name": "Eldritch",
    "isDark": true,
    "colors": {
      "background": "#212337",
      "surface": "#35374b",
      "surfaceHover": "#4a4c60",
      "surfaceElevated": "#404256",
      "text": "#ebfafa",
      "textSecondary": "#8e9fee",
      "textMuted": "#95a5dd",
      "primary": "#9071f4",
      "primaryHover": "#a48cf2",
      "primaryLight": "#c3a4ff",
      "primarySubtle": "#404256",
      "secondary": "#04d1f9",
      "secondaryHover": "#66e4fd",
      "accent": "#f9515d",
      "accentHover": "#f16c75",
      "success": "#37f499",
      "border": "#616377",
      "borderSubtle": "#47495d",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#212337",
      "#ebfafa",
      "#f9515d",
      "#37f499",
      "#e9f941",
      "#9071f4",
      "#04d1f9",
      "#7081d0"
    ],
    "id": "eldritch"
  },
  {
    "name": "Eldritch dark",
    "isDark": true,
    "colors": {
      "background": "#171928",
      "surface": "#2b2d3c",
      "surfaceHover": "#404251",
      "surfaceElevated": "#363847",
      "text": "#ebfafa",
      "textSecondary": "#7f90df",
      "textMuted": "#95a5dd",
      "primary": "#9071f4",
      "primaryHover": "#a48cf2",
      "primaryLight": "#c3a4ff",
      "primarySubtle": "#363847",
      "secondary": "#04d1f9",
      "secondaryHover": "#66e4fd",
      "accent": "#f9515d",
      "accentHover": "#f16c75",
      "success": "#37f499",
      "border": "#575968",
      "borderSubtle": "#3d3f4e",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#171928",
      "#ebfafa",
      "#f9515d",
      "#37f499",
      "#e9f941",
      "#9071f4",
      "#04d1f9",
      "#7081d0"
    ],
    "id": "eldritch-dark"
  },
  {
    "name": "ENCOM",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#00a595",
      "textSecondary": "#7e7e7e",
      "textMuted": "#4a7b77",
      "primary": "#0081ff",
      "primaryHover": "#0000ff",
      "primaryLight": "#33b4ff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#008b8b",
      "secondaryHover": "#00cdcd",
      "accent": "#9f0000",
      "accentHover": "#ff0000",
      "success": "#008b00",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#00a595",
      "#9f0000",
      "#008b00",
      "#ffcf00",
      "#0081ff",
      "#008b8b",
      "#545454"
    ],
    "id": "encom"
  },
  {
    "name": "Everforest Light Hard",
    "isDark": false,
    "colors": {
      "background": "#fffbef",
      "surface": "#f7f3e7",
      "surfaceHover": "#ebe7db",
      "surfaceElevated": "#faf6ea",
      "text": "#5c6a72",
      "textSecondary": "#647363",
      "textMuted": "#77857d",
      "primary": "#3a94c5",
      "primaryHover": "#146e9f",
      "primaryLight": "#87e1ff",
      "primarySubtle": "#f2eee2",
      "secondary": "#35a77c",
      "secondaryHover": "#0f8156",
      "accent": "#f85552",
      "accentHover": "#d22f2c",
      "success": "#8da101",
      "border": "#d9d5c9",
      "borderSubtle": "#ebe7db",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#fffbef",
      "#5c6a72",
      "#f85552",
      "#8da101",
      "#dfa000",
      "#3a94c5",
      "#35a77c",
      "#829181"
    ],
    "id": "everforest-light-hard"
  },
  {
    "name": "Flexoki (Light)",
    "isDark": false,
    "colors": {
      "background": "#fffcf0",
      "surface": "#f7f4e8",
      "surfaceHover": "#ebe8dc",
      "surfaceElevated": "#faf7eb",
      "text": "#100f0f",
      "textSecondary": "#6f6e69",
      "textMuted": "#52524e",
      "primary": "#4385be",
      "primaryHover": "#1d5f98",
      "primaryLight": "#90d2ff",
      "primarySubtle": "#f2efe3",
      "secondary": "#3aa99f",
      "secondaryHover": "#148379",
      "accent": "#d14d41",
      "accentHover": "#ab271b",
      "success": "#879a39",
      "border": "#d9d6ca",
      "borderSubtle": "#ebe8dc",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#fffcf0",
      "#100f0f",
      "#d14d41",
      "#879a39",
      "#d0a215",
      "#4385be",
      "#3aa99f",
      "#6f6e69"
    ],
    "id": "flexoki-light"
  },
  {
    "name": "FrontEndDelight",
    "isDark": true,
    "colors": {
      "background": "#1b1b1d",
      "surface": "#2f2f31",
      "surfaceHover": "#444446",
      "surfaceElevated": "#3a3a3c",
      "text": "#b2b2b2",
      "textSecondary": "#5eac6c",
      "textMuted": "#75ac7f",
      "primary": "#387cc3",
      "primaryHover": "#3393c9",
      "primaryLight": "#5fa3ea",
      "primarySubtle": "#3a3a3c",
      "secondary": "#3ba0a5",
      "secondaryHover": "#4ebce5",
      "accent": "#f8501a",
      "accentHover": "#f64319",
      "success": "#565746",
      "border": "#5b5b5d",
      "borderSubtle": "#414143",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1b1b1d",
      "#acacac",
      "#f8501a",
      "#565746",
      "#f9761d",
      "#2c70b7",
      "#3ba0a5",
      "#5eac6c"
    ],
    "id": "frontenddelight"
  },
  {
    "name": "FunForrest",
    "isDark": true,
    "colors": {
      "background": "#241200",
      "surface": "#382614",
      "surfaceHover": "#4d3b29",
      "surfaceElevated": "#43311f",
      "text": "#ddc165",
      "textSecondary": "#a28d78",
      "textMuted": "#9e865c",
      "primary": "#4698a2",
      "primaryHover": "#7cc9ce",
      "primaryLight": "#79cbd5",
      "primarySubtle": "#43311f",
      "secondary": "#d98112",
      "secondaryHover": "#e6a96b",
      "accent": "#d5252b",
      "accentHover": "#e4591b",
      "success": "#909b00",
      "border": "#645240",
      "borderSubtle": "#4a3826",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#241200",
      "#ddc165",
      "#d5252b",
      "#909b00",
      "#bd8a13",
      "#4698a2",
      "#d98112",
      "#7e6954"
    ],
    "id": "funforrest"
  },
  {
    "name": "Galaxy",
    "isDark": true,
    "colors": {
      "background": "#1c2836",
      "surface": "#303c4a",
      "surfaceHover": "#45515f",
      "surfaceElevated": "#3b4755",
      "text": "#ffffff",
      "textSecondary": "#a5a5a5",
      "textMuted": "#9f9f9f",
      "primary": "#589cf5",
      "primaryHover": "#589cf5",
      "primaryLight": "#8bcfff",
      "primarySubtle": "#3b4755",
      "secondary": "#1e9ee6",
      "secondaryHover": "#3978bb",
      "accent": "#f9555f",
      "accentHover": "#fa8b8e",
      "success": "#20af89",
      "border": "#5c6876",
      "borderSubtle": "#424e5c",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1c2836",
      "#ffffff",
      "#f9555f",
      "#20af89",
      "#fdf029",
      "#589cf5",
      "#1e9ee6",
      "#545454"
    ],
    "id": "galaxy"
  },
  {
    "name": "Ghostty Default",
    "isDark": true,
    "colors": {
      "background": "#292c33",
      "surface": "#3d4047",
      "surfaceHover": "#52555c",
      "surfaceElevated": "#484b52",
      "text": "#ffffff",
      "textSecondary": "#ababab",
      "textMuted": "#a6a6a6",
      "primary": "#88a1bb",
      "primaryHover": "#83a5d6",
      "primaryLight": "#bbd4ee",
      "primarySubtle": "#484b52",
      "secondary": "#95bdb7",
      "secondaryHover": "#83beb1",
      "accent": "#bf6b69",
      "accentHover": "#c55757",
      "success": "#b7bd73",
      "border": "#696c73",
      "borderSubtle": "#4f5259",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#292c33",
      "#ffffff",
      "#bf6b69",
      "#b7bd73",
      "#e9c880",
      "#88a1bb",
      "#95bdb7",
      "#666666"
    ],
    "id": "ghostty-default"
  },
  {
    "name": "Github",
    "isDark": false,
    "colors": {
      "background": "#f4f4f4",
      "surface": "#ececec",
      "surfaceHover": "#e0e0e0",
      "surfaceElevated": "#efefef",
      "text": "#3e3e3e",
      "textSecondary": "#666666",
      "textMuted": "#5a5a5a",
      "primary": "#003e8a",
      "primaryHover": "#001864",
      "primaryLight": "#4d8bd7",
      "primarySubtle": "#e7e7e7",
      "secondary": "#89d1ec",
      "secondaryHover": "#63abc6",
      "accent": "#970b16",
      "accentHover": "#710000",
      "success": "#07962a",
      "border": "#cecece",
      "borderSubtle": "#e0e0e0",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f4f4f4",
      "#3e3e3e",
      "#970b16",
      "#07962a",
      "#f7edc7",
      "#003e8a",
      "#89d1ec",
      "#666666"
    ],
    "id": "github"
  },
  {
    "name": "GitHub Dark",
    "isDark": true,
    "colors": {
      "background": "#0d1117",
      "surface": "#21252b",
      "surfaceHover": "#363a40",
      "surfaceElevated": "#2c3036",
      "text": "#c9d1d9",
      "textSecondary": "#868e99",
      "textMuted": "#89919b",
      "primary": "#58a6ff",
      "primaryHover": "#79c0ff",
      "primaryLight": "#8bd9ff",
      "primarySubtle": "#2c3036",
      "secondary": "#39c5cf",
      "secondaryHover": "#56d4dd",
      "accent": "#ff7b72",
      "accentHover": "#ffa198",
      "success": "#3fb950",
      "border": "#4d5157",
      "borderSubtle": "#33373d",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0d1117",
      "#c9d1d9",
      "#ff7b72",
      "#3fb950",
      "#d29922",
      "#58a6ff",
      "#39c5cf",
      "#6e7681"
    ],
    "id": "github-dark"
  },
  {
    "name": "GitHub Dark Colorblind",
    "isDark": true,
    "colors": {
      "background": "#0d1117",
      "surface": "#21252b",
      "surfaceHover": "#363a40",
      "surfaceElevated": "#2c3036",
      "text": "#c9d1d9",
      "textSecondary": "#868e99",
      "textMuted": "#89919b",
      "primary": "#58a6ff",
      "primaryHover": "#79c0ff",
      "primaryLight": "#8bd9ff",
      "primarySubtle": "#2c3036",
      "secondary": "#39c5cf",
      "secondaryHover": "#56d4dd",
      "accent": "#ec8e2c",
      "accentHover": "#fdac54",
      "success": "#58a6ff",
      "border": "#4d5157",
      "borderSubtle": "#33373d",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0d1117",
      "#c9d1d9",
      "#ec8e2c",
      "#58a6ff",
      "#d29922",
      "#58a6ff",
      "#39c5cf",
      "#6e7681"
    ],
    "id": "github-dark-colorblind"
  },
  {
    "name": "GitHub Dark High Contrast",
    "isDark": true,
    "colors": {
      "background": "#0a0c10",
      "surface": "#1e2024",
      "surfaceHover": "#333539",
      "surfaceElevated": "#292b2f",
      "text": "#f0f3f6",
      "textSecondary": "#9ea7b3",
      "textMuted": "#b7bec7",
      "primary": "#71b7ff",
      "primaryHover": "#91cbff",
      "primaryLight": "#a4eaff",
      "primarySubtle": "#292b2f",
      "secondary": "#39c5cf",
      "secondaryHover": "#56d4dd",
      "accent": "#ff9492",
      "accentHover": "#ffb1af",
      "success": "#26cd4d",
      "border": "#4a4c50",
      "borderSubtle": "#303236",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0a0c10",
      "#f0f3f6",
      "#ff9492",
      "#26cd4d",
      "#f0b72f",
      "#71b7ff",
      "#39c5cf",
      "#9ea7b3"
    ],
    "id": "github-dark-high-contrast"
  },
  {
    "name": "GitHub Light",
    "isDark": false,
    "colors": {
      "background": "#ffffff",
      "surface": "#f7f7f7",
      "surfaceHover": "#ebebeb",
      "surfaceElevated": "#fafafa",
      "text": "#24292f",
      "textSecondary": "#57606a",
      "textMuted": "#484f58",
      "primary": "#0969da",
      "primaryHover": "#0043b4",
      "primaryLight": "#56b6ff",
      "primarySubtle": "#f2f2f2",
      "secondary": "#1b7c83",
      "secondaryHover": "#00565d",
      "accent": "#cf222e",
      "accentHover": "#a90008",
      "success": "#116329",
      "border": "#d9d9d9",
      "borderSubtle": "#ebebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ffffff",
      "#24292f",
      "#cf222e",
      "#116329",
      "#4d2d00",
      "#0969da",
      "#1b7c83",
      "#57606a"
    ],
    "id": "github-light"
  },
  {
    "name": "GitHub Light Colorblind",
    "isDark": false,
    "colors": {
      "background": "#ffffff",
      "surface": "#f7f7f7",
      "surfaceHover": "#ebebeb",
      "surfaceElevated": "#fafafa",
      "text": "#24292f",
      "textSecondary": "#57606a",
      "textMuted": "#484f58",
      "primary": "#0969da",
      "primaryHover": "#0043b4",
      "primaryLight": "#56b6ff",
      "primarySubtle": "#f2f2f2",
      "secondary": "#1b7c83",
      "secondaryHover": "#00565d",
      "accent": "#b35900",
      "accentHover": "#8d3300",
      "success": "#0550ae",
      "border": "#d9d9d9",
      "borderSubtle": "#ebebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ffffff",
      "#24292f",
      "#b35900",
      "#0550ae",
      "#4d2d00",
      "#0969da",
      "#1b7c83",
      "#57606a"
    ],
    "id": "github-light-colorblind"
  },
  {
    "name": "GitHub Light High Contrast",
    "isDark": false,
    "colors": {
      "background": "#ffffff",
      "surface": "#f7f7f7",
      "surfaceHover": "#ebebeb",
      "surfaceElevated": "#fafafa",
      "text": "#0e1116",
      "textSecondary": "#4b535d",
      "textMuted": "#393f48",
      "primary": "#0349b4",
      "primaryHover": "#00238e",
      "primaryLight": "#5096ff",
      "primarySubtle": "#f2f2f2",
      "secondary": "#1b7c83",
      "secondaryHover": "#00565d",
      "accent": "#a0111f",
      "accentHover": "#7a0000",
      "success": "#024c1a",
      "border": "#d9d9d9",
      "borderSubtle": "#ebebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ffffff",
      "#0e1116",
      "#a0111f",
      "#024c1a",
      "#3f2200",
      "#0349b4",
      "#1b7c83",
      "#4b535d"
    ],
    "id": "github-light-high-contrast"
  },
  {
    "name": "Gnome Light",
    "isDark": false,
    "colors": {
      "background": "#ffffff",
      "surface": "#f7f7f7",
      "surfaceHover": "#ebebeb",
      "surfaceElevated": "#fafafa",
      "text": "#171421",
      "textSecondary": "#5e5c64",
      "textMuted": "#494650",
      "primary": "#12488b",
      "primaryHover": "#002265",
      "primaryLight": "#5f95d8",
      "primarySubtle": "#f2f2f2",
      "secondary": "#2aa1b3",
      "secondaryHover": "#047b8d",
      "accent": "#c01c28",
      "accentHover": "#9a0002",
      "success": "#26a269",
      "border": "#d9d9d9",
      "borderSubtle": "#ebebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ffffff",
      "#171421",
      "#c01c28",
      "#26a269",
      "#a2734c",
      "#12488b",
      "#2aa1b3",
      "#5e5c64"
    ],
    "id": "gnomelight"
  },
  {
    "name": "graphite",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#ffffff",
      "textSecondary": "#808080",
      "textMuted": "#737373",
      "primary": "#989898",
      "primaryHover": "#989898",
      "primaryLight": "#cbcbcb",
      "primarySubtle": "#1f1f1f",
      "secondary": "#585858",
      "secondaryHover": "#585858",
      "accent": "#646464",
      "accentHover": "#646464",
      "success": "#8e8e8e",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#ffffff",
      "#646464",
      "#8e8e8e",
      "#b9b9b9",
      "#989898",
      "#585858",
      "#262626"
    ],
    "id": "graphite"
  },
  {
    "name": "Gruvbox Dark",
    "isDark": true,
    "colors": {
      "background": "#282828",
      "surface": "#3c3c3c",
      "surfaceHover": "#515151",
      "surfaceElevated": "#474747",
      "text": "#ebdbb2",
      "textSecondary": "#b3a495",
      "textMuted": "#ad9d87",
      "primary": "#519194",
      "primaryHover": "#83a598",
      "primaryLight": "#78b8bb",
      "primarySubtle": "#474747",
      "secondary": "#689d6a",
      "secondaryHover": "#8ec07c",
      "accent": "#cc241d",
      "accentHover": "#fb4934",
      "success": "#98971a",
      "border": "#686868",
      "borderSubtle": "#4e4e4e",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#282828",
      "#ebdbb2",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#689d6a",
      "#928374"
    ],
    "id": "gruvbox-dark"
  },
  {
    "name": "Gruvbox Dark Hard",
    "isDark": true,
    "colors": {
      "background": "#1d2021",
      "surface": "#313435",
      "surfaceHover": "#46494a",
      "surfaceElevated": "#3c3f40",
      "text": "#ebdbb2",
      "textSecondary": "#aa9b8c",
      "textMuted": "#ad9d87",
      "primary": "#48888b",
      "primaryHover": "#83a598",
      "primaryLight": "#78b8bb",
      "primarySubtle": "#3c3f40",
      "secondary": "#689d6a",
      "secondaryHover": "#8ec07c",
      "accent": "#cc241d",
      "accentHover": "#fb4934",
      "success": "#98971a",
      "border": "#5d6061",
      "borderSubtle": "#434647",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1d2021",
      "#ebdbb2",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#689d6a",
      "#928374"
    ],
    "id": "gruvbox-dark-hard"
  },
  {
    "name": "Gruvbox Light",
    "isDark": false,
    "colors": {
      "background": "#fbf1c7",
      "surface": "#f3e9bf",
      "surfaceHover": "#e7ddb3",
      "surfaceElevated": "#f6ecc2",
      "text": "#3c3836",
      "textSecondary": "#746556",
      "textMuted": "#786c61",
      "primary": "#458588",
      "primaryHover": "#1f5f62",
      "primaryLight": "#92d2d5",
      "primarySubtle": "#eee4ba",
      "secondary": "#689d6a",
      "secondaryHover": "#427744",
      "accent": "#cc241d",
      "accentHover": "#a60000",
      "success": "#98971a",
      "border": "#d5cba1",
      "borderSubtle": "#e7ddb3",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#fbf1c7",
      "#3c3836",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#689d6a",
      "#928374"
    ],
    "id": "gruvbox-light"
  },
  {
    "name": "Gruvbox Light Hard",
    "isDark": false,
    "colors": {
      "background": "#f9f5d7",
      "surface": "#f1edcf",
      "surfaceHover": "#e5e1c3",
      "surfaceElevated": "#f4f0d2",
      "text": "#3c3836",
      "textSecondary": "#776859",
      "textMuted": "#786c61",
      "primary": "#458588",
      "primaryHover": "#1f5f62",
      "primaryLight": "#92d2d5",
      "primarySubtle": "#ece8ca",
      "secondary": "#689d6a",
      "secondaryHover": "#427744",
      "accent": "#cc241d",
      "accentHover": "#a60000",
      "success": "#98971a",
      "border": "#d3cfb1",
      "borderSubtle": "#e5e1c3",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f9f5d7",
      "#3c3836",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#689d6a",
      "#928374"
    ],
    "id": "gruvbox-light-hard"
  },
  {
    "name": "Gruvbox Light Soft",
    "isDark": false,
    "colors": {
      "background": "#f2e5bc",
      "surface": "#eaddb4",
      "surfaceHover": "#ded1a8",
      "surfaceElevated": "#ede0b7",
      "text": "#3c3836",
      "textSecondary": "#6e5f50",
      "textMuted": "#786c61",
      "primary": "#458588",
      "primaryHover": "#1f5f62",
      "primaryLight": "#92d2d5",
      "primarySubtle": "#e5d8af",
      "secondary": "#689d6a",
      "secondaryHover": "#427744",
      "accent": "#cc241d",
      "accentHover": "#a60000",
      "success": "#98971a",
      "border": "#ccbf96",
      "borderSubtle": "#ded1a8",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f2e5bc",
      "#3c3836",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#689d6a",
      "#928374"
    ],
    "id": "gruvbox-light-soft"
  },
  {
    "name": "Gruvbox Material Dark Hard",
    "isDark": true,
    "colors": {
      "background": "#1d2021",
      "surface": "#313435",
      "surfaceHover": "#46494a",
      "surfaceElevated": "#3c3f40",
      "text": "#d4be98",
      "textSecondary": "#aa9b8c",
      "textMuted": "#a6957f",
      "primary": "#7daea3",
      "primaryHover": "#7daea3",
      "primaryLight": "#b0e1d6",
      "primarySubtle": "#3c3f40",
      "secondary": "#89b482",
      "secondaryHover": "#89b482",
      "accent": "#ea6962",
      "accentHover": "#ea6962",
      "success": "#a9b665",
      "border": "#5d6061",
      "borderSubtle": "#434647",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1d2021",
      "#d4be98",
      "#ea6962",
      "#a9b665",
      "#e78a4e",
      "#7daea3",
      "#89b482",
      "#928374"
    ],
    "id": "gruvboxmaterialdarkhard"
  },
  {
    "name": "Gruvbox Material Light Hard",
    "isDark": false,
    "colors": {
      "background": "#f9f5d7",
      "surface": "#f1edcf",
      "surfaceHover": "#e5e1c3",
      "surfaceElevated": "#f4f0d2",
      "text": "#654735",
      "textSecondary": "#776859",
      "textMuted": "#857161",
      "primary": "#45707a",
      "primaryHover": "#1f4a54",
      "primaryLight": "#92bdc7",
      "primarySubtle": "#ece8ca",
      "secondary": "#4c7a5d",
      "secondaryHover": "#265437",
      "accent": "#c14a4a",
      "accentHover": "#9b2424",
      "success": "#6c782e",
      "border": "#d3cfb1",
      "borderSubtle": "#e5e1c3",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f9f5d7",
      "#654735",
      "#c14a4a",
      "#6c782e",
      "#c35e0a",
      "#45707a",
      "#4c7a5d",
      "#928374"
    ],
    "id": "gruvboxmateriallighthard"
  },
  {
    "name": "Gruvbox Material Light Medium",
    "isDark": false,
    "colors": {
      "background": "#fbf1c7",
      "surface": "#f3e9bf",
      "surfaceHover": "#e7ddb3",
      "surfaceElevated": "#f6ecc2",
      "text": "#654735",
      "textSecondary": "#746556",
      "textMuted": "#857161",
      "primary": "#45707a",
      "primaryHover": "#1f4a54",
      "primaryLight": "#92bdc7",
      "primarySubtle": "#eee4ba",
      "secondary": "#4c7a5d",
      "secondaryHover": "#265437",
      "accent": "#c14a4a",
      "accentHover": "#9b2424",
      "success": "#6c782e",
      "border": "#d5cba1",
      "borderSubtle": "#e7ddb3",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#fbf1c7",
      "#654735",
      "#c14a4a",
      "#6c782e",
      "#c35e0a",
      "#45707a",
      "#4c7a5d",
      "#928374"
    ],
    "id": "gruvboxmateriallightmedium"
  },
  {
    "name": "Gruvbox Material Light Soft",
    "isDark": false,
    "colors": {
      "background": "#f2e5bc",
      "surface": "#eaddb4",
      "surfaceHover": "#ded1a8",
      "surfaceElevated": "#ede0b7",
      "text": "#654735",
      "textSecondary": "#6e5f50",
      "textMuted": "#857161",
      "primary": "#45707a",
      "primaryHover": "#1f4a54",
      "primaryLight": "#92bdc7",
      "primarySubtle": "#e5d8af",
      "secondary": "#4c7a5d",
      "secondaryHover": "#265437",
      "accent": "#c14a4a",
      "accentHover": "#9b2424",
      "success": "#6c782e",
      "border": "#ccbf96",
      "borderSubtle": "#ded1a8",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f2e5bc",
      "#654735",
      "#c14a4a",
      "#6c782e",
      "#c35e0a",
      "#45707a",
      "#4c7a5d",
      "#928374"
    ],
    "id": "gruvboxmateriallightsoft"
  },
  {
    "name": "H-PUX",
    "isDark": false,
    "colors": {
      "background": "#d1bca7",
      "surface": "#c9b49f",
      "surfaceHover": "#bda893",
      "surfaceElevated": "#ccb7a2",
      "text": "#000000",
      "textSecondary": "#484848",
      "textMuted": "#3b3b3b",
      "primary": "#003cb4",
      "primaryHover": "#00168e",
      "primaryLight": "#4d89ff",
      "primarySubtle": "#c4af9a",
      "secondary": "#008b8b",
      "secondaryHover": "#006565",
      "accent": "#8c0000",
      "accentHover": "#660000",
      "success": "#007d00",
      "border": "#ab9681",
      "borderSubtle": "#bda893",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#d1bca7",
      "#000000",
      "#8c0000",
      "#007d00",
      "#8c7000",
      "#003cb4",
      "#008b8b",
      "#545454"
    ],
    "id": "h-pux"
  },
  {
    "name": "HardHacker",
    "isDark": true,
    "colors": {
      "background": "#282433",
      "surface": "#3c3847",
      "surfaceHover": "#514d5c",
      "surfaceElevated": "#474352",
      "text": "#eee9fc",
      "textSecondary": "#a89fc2",
      "textMuted": "#aea7c5",
      "primary": "#b1baf4",
      "primaryHover": "#b1baf4",
      "primaryLight": "#e4edff",
      "primarySubtle": "#474352",
      "secondary": "#b3f4f3",
      "secondaryHover": "#b3f4f3",
      "accent": "#e965a5",
      "accentHover": "#e965a5",
      "success": "#b1f2a7",
      "border": "#686473",
      "borderSubtle": "#4e4a59",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#282433",
      "#eee9fc",
      "#e965a5",
      "#b1f2a7",
      "#ebde76",
      "#b1baf4",
      "#b3f4f3",
      "#938aad"
    ],
    "id": "hardhacker"
  },
  {
    "name": "Harper",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#a7a39c",
      "textSecondary": "#837f7b",
      "textMuted": "#817d78",
      "primary": "#489d48",
      "primaryHover": "#489d48",
      "primaryLight": "#7bd07b",
      "primarySubtle": "#1f1f1f",
      "secondary": "#f4bed6",
      "secondaryHover": "#f4bed6",
      "accent": "#f7b63e",
      "accentHover": "#f7b63e",
      "success": "#7fb5e1",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#a7a39c",
      "#f7b63e",
      "#7fb5e1",
      "#d6da24",
      "#489d48",
      "#f4bed6",
      "#716d69"
    ],
    "id": "harper"
  },
  {
    "name": "Hipster Green",
    "isDark": true,
    "colors": {
      "background": "#0f0a05",
      "surface": "#231e19",
      "surfaceHover": "#38332e",
      "surfaceElevated": "#2e2924",
      "text": "#84c137",
      "textSecondary": "#878787",
      "textMuted": "#72845b",
      "primary": "#246db2",
      "primaryHover": "#0000ff",
      "primaryLight": "#57a0e5",
      "primarySubtle": "#2e2924",
      "secondary": "#00a6b2",
      "secondaryHover": "#00e5e5",
      "accent": "#b6204a",
      "accentHover": "#e50000",
      "success": "#00a600",
      "border": "#4f4a45",
      "borderSubtle": "#35302b",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0f0a05",
      "#84c137",
      "#b6204a",
      "#00a600",
      "#bebe00",
      "#246db2",
      "#00a6b2",
      "#666666"
    ],
    "id": "hipster-green"
  },
  {
    "name": "IR Black",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#f1f1f1",
      "textSecondary": "#7e7e7e",
      "textMuted": "#9e9e9e",
      "primary": "#96cafd",
      "primaryHover": "#b5dcfe",
      "primaryLight": "#c9fdff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#c6c4fd",
      "secondaryHover": "#dfdffd",
      "accent": "#fa6c5f",
      "accentHover": "#fcb6af",
      "success": "#a8fe60",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#f1f1f1",
      "#fa6c5f",
      "#a8fe60",
      "#fffeb6",
      "#96cafd",
      "#c6c4fd",
      "#7b7b7b"
    ],
    "id": "ir-black"
  },
  {
    "name": "Japanesque",
    "isDark": true,
    "colors": {
      "background": "#1d1d1d",
      "surface": "#313131",
      "surfaceHover": "#464646",
      "surfaceElevated": "#3c3c3c",
      "text": "#f7f6ec",
      "textSecondary": "#979997",
      "textMuted": "#91928d",
      "primary": "#4c99d3",
      "primaryHover": "#135879",
      "primaryLight": "#7fccff",
      "primarySubtle": "#3c3c3c",
      "secondary": "#389aac",
      "secondaryHover": "#76bbca",
      "accent": "#ce3e60",
      "accentHover": "#d18ea6",
      "success": "#7bb75b",
      "border": "#5d5d5d",
      "borderSubtle": "#434343",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1d1d1d",
      "#f7f6ec",
      "#ce3e60",
      "#7bb75b",
      "#e8b32a",
      "#4c99d3",
      "#389aac",
      "#585a58"
    ],
    "id": "japanesque"
  },
  {
    "name": "Jellybeans",
    "isDark": true,
    "colors": {
      "background": "#111111",
      "surface": "#252525",
      "surfaceHover": "#3a3a3a",
      "surfaceElevated": "#303030",
      "text": "#dedede",
      "textSecondary": "#bdbdbd",
      "textMuted": "#c7c7c7",
      "primary": "#96bddb",
      "primaryHover": "#b1d7f6",
      "primaryLight": "#c9f0ff",
      "primarySubtle": "#303030",
      "secondary": "#00988e",
      "secondaryHover": "#19b2a7",
      "accent": "#e17373",
      "accentHover": "#ffa0a0",
      "success": "#94b978",
      "border": "#515151",
      "borderSubtle": "#373737",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#111111",
      "#dedede",
      "#e17373",
      "#94b978",
      "#ffb97b",
      "#96bddb",
      "#00988e",
      "#bdbdbd"
    ],
    "id": "jellybeans"
  },
  {
    "name": "Kanagawa",
    "isDark": true,
    "colors": {
      "background": "#1f1f28",
      "surface": "#33333c",
      "surfaceHover": "#484851",
      "surfaceElevated": "#3e3e47",
      "text": "#dcd7ba",
      "textSecondary": "#9f9e96",
      "textMuted": "#989687",
      "primary": "#7e9cd8",
      "primaryHover": "#7fb4ca",
      "primaryLight": "#b1cfff",
      "primarySubtle": "#3e3e47",
      "secondary": "#6a9589",
      "secondaryHover": "#7aa89f",
      "accent": "#c34043",
      "accentHover": "#e82424",
      "success": "#76946a",
      "border": "#5f5f68",
      "borderSubtle": "#45454e",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1f1f28",
      "#dcd7ba",
      "#c34043",
      "#76946a",
      "#c0a36e",
      "#7e9cd8",
      "#6a9589",
      "#727169"
    ],
    "id": "kanagawa"
  },
  {
    "name": "Kanagawa_dragon",
    "isDark": true,
    "colors": {
      "background": "#181616",
      "surface": "#2c2a2a",
      "surfaceHover": "#413f3f",
      "surfaceElevated": "#373535",
      "text": "#c5c9c5",
      "textSecondary": "#a6a69c",
      "textMuted": "#afb1a8",
      "primary": "#8ba4b0",
      "primaryHover": "#7fb4ca",
      "primaryLight": "#bed7e3",
      "primarySubtle": "#373535",
      "secondary": "#8ea4a2",
      "secondaryHover": "#7aa89f",
      "accent": "#c4746e",
      "accentHover": "#e46876",
      "success": "#8a9a7b",
      "border": "#585656",
      "borderSubtle": "#3e3c3c",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#181616",
      "#c5c9c5",
      "#c4746e",
      "#8a9a7b",
      "#c4b28a",
      "#8ba4b0",
      "#8ea4a2",
      "#a6a69c"
    ],
    "id": "kanagawa-dragon"
  },
  {
    "name": "Kanagawa_light",
    "isDark": false,
    "colors": {
      "background": "#f2ecbc",
      "surface": "#eae4b4",
      "surfaceHover": "#ded8a8",
      "surfaceElevated": "#ede7b7",
      "text": "#545464",
      "textSecondary": "#66655c",
      "textMuted": "#777675",
      "primary": "#4d699b",
      "primaryHover": "#274375",
      "primaryLight": "#9ab6e8",
      "primarySubtle": "#e5dfaf",
      "secondary": "#597b75",
      "secondaryHover": "#33554f",
      "accent": "#c84053",
      "accentHover": "#a21a2d",
      "success": "#6f894e",
      "border": "#ccc696",
      "borderSubtle": "#ded8a8",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f2ecbc",
      "#545464",
      "#c84053",
      "#6f894e",
      "#77713f",
      "#4d699b",
      "#597b75",
      "#8a8980"
    ],
    "id": "kanagawa-light"
  },
  {
    "name": "Kaolin Aurora",
    "isDark": true,
    "colors": {
      "background": "#14191e",
      "surface": "#282d32",
      "surfaceHover": "#3d4247",
      "surfaceElevated": "#33383d",
      "text": "#e6e6e8",
      "textSecondary": "#9392a7",
      "textMuted": "#8d8d9c",
      "primary": "#4ca6e8",
      "primaryHover": "#91b9c7",
      "primaryLight": "#7fd9ff",
      "primarySubtle": "#33383d",
      "secondary": "#49bdb0",
      "secondaryHover": "#0d9c94",
      "accent": "#e55c7a",
      "accentHover": "#cd5c60",
      "success": "#31e183",
      "border": "#54595e",
      "borderSubtle": "#3a3f44",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#14191e",
      "#e6e6e8",
      "#e55c7a",
      "#31e183",
      "#f5c791",
      "#4ca6e8",
      "#49bdb0",
      "#454459"
    ],
    "id": "kaolin-aurora"
  },
  {
    "name": "Kaolin Breeze",
    "isDark": false,
    "colors": {
      "background": "#ebe8e4",
      "surface": "#e3e0dc",
      "surfaceHover": "#d7d4d0",
      "surfaceElevated": "#e6e3df",
      "text": "#383e3f",
      "textSecondary": "#5f664a",
      "textMuted": "#686f5c",
      "primary": "#2683b5",
      "primaryHover": "#005d8f",
      "primaryLight": "#73d0ff",
      "primarySubtle": "#dedbd7",
      "secondary": "#48a9a9",
      "secondaryHover": "#228383",
      "accent": "#cd5c60",
      "accentHover": "#a7363a",
      "success": "#39855f",
      "border": "#c5c2be",
      "borderSubtle": "#d7d4d0",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ebe8e4",
      "#383e3f",
      "#cd5c60",
      "#39855f",
      "#b87e3c",
      "#2683b5",
      "#48a9a9",
      "#7d8468"
    ],
    "id": "kaolin-breeze"
  },
  {
    "name": "Kaolin Dark",
    "isDark": true,
    "colors": {
      "background": "#18181b",
      "surface": "#2c2c2f",
      "surfaceHover": "#414144",
      "surfaceElevated": "#37373a",
      "text": "#e4e4e8",
      "textSecondary": "#8d9799",
      "textMuted": "#a3aaad",
      "primary": "#91b9c7",
      "primaryHover": "#97b8de",
      "primaryLight": "#c4ecfa",
      "primarySubtle": "#37373a",
      "secondary": "#4d9391",
      "secondaryHover": "#5096ab",
      "accent": "#cd5c60",
      "accentHover": "#e36d5b",
      "success": "#6fb593",
      "border": "#58585b",
      "borderSubtle": "#3e3e41",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#18181b",
      "#e4e4e8",
      "#cd5c60",
      "#6fb593",
      "#dbac66",
      "#91b9c7",
      "#4d9391",
      "#879193"
    ],
    "id": "kaolin-dark"
  },
  {
    "name": "Kaolin Galaxy",
    "isDark": true,
    "colors": {
      "background": "#212026",
      "surface": "#35343a",
      "surfaceHover": "#4a494f",
      "surfaceElevated": "#403f45",
      "text": "#e6e6e8",
      "textSecondary": "#a09ab4",
      "textMuted": "#9894a7",
      "primary": "#41b0f3",
      "primaryHover": "#2a57cc",
      "primaryLight": "#74e3ff",
      "primarySubtle": "#403f45",
      "secondary": "#6bd9db",
      "secondaryHover": "#0bc9cf",
      "accent": "#ef6787",
      "accentHover": "#d6224d",
      "success": "#49bdb0",
      "border": "#616066",
      "borderSubtle": "#47464c",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#212026",
      "#e6e6e8",
      "#ef6787",
      "#49bdb0",
      "#eed891",
      "#41b0f3",
      "#6bd9db",
      "#615b75"
    ],
    "id": "kaolin-galaxy"
  },
  {
    "name": "Kaolin Light",
    "isDark": false,
    "colors": {
      "background": "#edeeeb",
      "surface": "#e5e6e3",
      "surfaceHover": "#d9dad7",
      "surfaceElevated": "#e8e9e6",
      "text": "#353b3c",
      "textSecondary": "#4b5254",
      "textMuted": "#444b4d",
      "primary": "#3b84cc",
      "primaryHover": "#155ea6",
      "primaryLight": "#88d1ff",
      "primarySubtle": "#e0e1de",
      "secondary": "#6facb3",
      "secondaryHover": "#49868d",
      "accent": "#e84c58",
      "accentHover": "#c22632",
      "success": "#13665f",
      "border": "#c7c8c5",
      "borderSubtle": "#d9dad7",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#edeeeb",
      "#353b3c",
      "#e84c58",
      "#13665f",
      "#e36b3f",
      "#3b84cc",
      "#6facb3",
      "#4b5254"
    ],
    "id": "kaolin-light"
  },
  {
    "name": "Kaolin Ocean",
    "isDark": true,
    "colors": {
      "background": "#14141e",
      "surface": "#282832",
      "surfaceHover": "#3d3d47",
      "surfaceElevated": "#33333d",
      "text": "#e6e6e8",
      "textSecondary": "#8a9294",
      "textMuted": "#868b8d",
      "primary": "#4ca6e8",
      "primaryHover": "#53859d",
      "primaryLight": "#7fd9ff",
      "primarySubtle": "#33333d",
      "secondary": "#6bd9db",
      "secondaryHover": "#4d9391",
      "accent": "#e84c58",
      "accentHover": "#e84c58",
      "success": "#35bf88",
      "border": "#54545e",
      "borderSubtle": "#3a3a44",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#14141e",
      "#e6e6e8",
      "#e84c58",
      "#35bf88",
      "#dbac66",
      "#4ca6e8",
      "#6bd9db",
      "#545c5e"
    ],
    "id": "kaolin-ocean"
  },
  {
    "name": "Kaolin Temple",
    "isDark": true,
    "colors": {
      "background": "#2b2b2f",
      "surface": "#3f3f43",
      "surfaceHover": "#545458",
      "surfaceElevated": "#4a4a4e",
      "text": "#eedcc1",
      "textSecondary": "#a2acae",
      "textMuted": "#a3a59e",
      "primary": "#4eb8ca",
      "primaryHover": "#91b9c7",
      "primaryLight": "#81ebfd",
      "primarySubtle": "#4a4a4e",
      "secondary": "#49bdb0",
      "secondaryHover": "#4fa8a3",
      "accent": "#ef6787",
      "accentHover": "#ba667d",
      "success": "#47ba99",
      "border": "#6b6b6f",
      "borderSubtle": "#515155",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#2b2b2f",
      "#eedcc1",
      "#ef6787",
      "#47ba99",
      "#eed891",
      "#4eb8ca",
      "#49bdb0",
      "#697375"
    ],
    "id": "kaolin-temple"
  },
  {
    "name": "Kokiri",
    "isDark": false,
    "colors": {
      "background": "#c5d8a0",
      "surface": "#bdd098",
      "surfaceHover": "#b1c48c",
      "surfaceElevated": "#c0d39b",
      "text": "#6d4215",
      "textSecondary": "#704518",
      "textMuted": "#704518",
      "primary": "#4a6a8a",
      "primaryHover": "#244464",
      "primaryLight": "#97b7d7",
      "primarySubtle": "#b8cb93",
      "secondary": "#4a7a7a",
      "secondaryHover": "#245454",
      "accent": "#b8860b",
      "accentHover": "#926000",
      "success": "#4a7a4a",
      "border": "#9fb27a",
      "borderSubtle": "#b1c48c",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#c5d8a0",
      "#704518",
      "#b8860b",
      "#4a7a4a",
      "#8a6830",
      "#4a6a8a",
      "#4a7a7a",
      "#704518"
    ],
    "id": "kokiri"
  },
  {
    "name": "Kurayami",
    "isDark": true,
    "colors": {
      "background": "#1c1c1c",
      "surface": "#303030",
      "surfaceHover": "#454545",
      "surfaceElevated": "#3b3b3b",
      "text": "#cccccc",
      "textSecondary": "#989898",
      "textMuted": "#919191",
      "primary": "#158c8a",
      "primaryHover": "#1a8fff",
      "primaryLight": "#48bfbd",
      "primarySubtle": "#3b3b3b",
      "secondary": "#1a8fff",
      "secondaryHover": "#14ffff",
      "accent": "#bf616a",
      "accentHover": "#b2201f",
      "success": "#00af87",
      "border": "#5c5c5c",
      "borderSubtle": "#424242",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1c1c1c",
      "#cccccc",
      "#bf616a",
      "#00af87",
      "#cecb00",
      "#158c8a",
      "#1a8fff",
      "#626262"
    ],
    "id": "kurayami"
  },
  {
    "name": "Leaf Light",
    "isDark": false,
    "colors": {
      "background": "#e1e4dc",
      "surface": "#d9dcd4",
      "surfaceHover": "#cdd0c8",
      "surfaceElevated": "#dcdfd7",
      "text": "#2e2c2f",
      "textSecondary": "#403f42",
      "textMuted": "#3b393c",
      "primary": "#4080b4",
      "primaryHover": "#2c6ca0",
      "primaryLight": "#9fdfff",
      "primarySubtle": "#d4d7cf",
      "secondary": "#489ca5",
      "secondaryHover": "#22767f",
      "accent": "#ba5860",
      "accentHover": "#94323a",
      "success": "#729b79",
      "border": "#bbbeb6",
      "borderSubtle": "#cdd0c8",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#e1e4dc",
      "#2e2c2f",
      "#ba5860",
      "#729b79",
      "#ccaa6c",
      "#5292c6",
      "#489ca5",
      "#403f42"
    ],
    "id": "leaf-light"
  },
  {
    "name": "LiquidCarbonTransparentInverse",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#afc2c2",
      "textSecondary": "#ffffff",
      "textMuted": "#e7eded",
      "primary": "#0099cc",
      "primaryHover": "#0099cc",
      "primaryLight": "#33ccff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#79c4cc",
      "secondaryHover": "#79c4cc",
      "accent": "#ff2f2f",
      "accentHover": "#ff2f2f",
      "success": "#549a6f",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#afc2c2",
      "#ff2f2f",
      "#549a6f",
      "#ccac00",
      "#0099cc",
      "#79c4cc",
      "#ffffff"
    ],
    "id": "liquidcarbontransparentinverse"
  },
  {
    "name": "Love Ghost",
    "isDark": false,
    "colors": {
      "background": "#ebe5e6",
      "surface": "#e3ddde",
      "surfaceHover": "#d7d1d2",
      "surfaceElevated": "#e6e0e1",
      "text": "#3a2830",
      "textSecondary": "#3a2830",
      "textMuted": "#3a2830",
      "primary": "#484058",
      "primaryHover": "#221a32",
      "primaryLight": "#958da5",
      "primarySubtle": "#ded8d9",
      "secondary": "#385050",
      "secondaryHover": "#122a2a",
      "accent": "#806068",
      "accentHover": "#5a3a42",
      "success": "#485848",
      "border": "#c5bfc0",
      "borderSubtle": "#d7d1d2",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ebe5e6",
      "#3a2830",
      "#806068",
      "#485848",
      "#604838",
      "#484058",
      "#385050",
      "#3a2830"
    ],
    "id": "love-ghost"
  },
  {
    "name": "Man Page",
    "isDark": false,
    "colors": {
      "background": "#fef49c",
      "surface": "#f6ec94",
      "surfaceHover": "#eae088",
      "surfaceElevated": "#f9ef97",
      "text": "#000000",
      "textSecondary": "#666666",
      "textMuted": "#474747",
      "primary": "#0000b2",
      "primaryHover": "#00008c",
      "primaryLight": "#4d4dff",
      "primarySubtle": "#f1e78f",
      "secondary": "#00a6b2",
      "secondaryHover": "#00808c",
      "accent": "#cc0000",
      "accentHover": "#a60000",
      "success": "#00a600",
      "border": "#d8ce76",
      "borderSubtle": "#eae088",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#fef49c",
      "#000000",
      "#cc0000",
      "#00a600",
      "#999900",
      "#0000b2",
      "#00a6b2",
      "#666666"
    ],
    "id": "man-page"
  },
  {
    "name": "Material",
    "isDark": false,
    "colors": {
      "background": "#eaeaea",
      "surface": "#e2e2e2",
      "surfaceHover": "#d6d6d6",
      "surfaceElevated": "#e5e5e5",
      "text": "#222221",
      "textSecondary": "#424242",
      "textMuted": "#383838",
      "primary": "#134eb2",
      "primaryHover": "#00288c",
      "primaryLight": "#609bff",
      "primarySubtle": "#dddddd",
      "secondary": "#0e707c",
      "secondaryHover": "#004a56",
      "accent": "#b7141e",
      "accentHover": "#910000",
      "success": "#457b23",
      "border": "#c4c4c4",
      "borderSubtle": "#d6d6d6",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#eaeaea",
      "#222221",
      "#b7141e",
      "#457b23",
      "#f5971d",
      "#134eb2",
      "#0e707c",
      "#424242"
    ],
    "id": "material"
  },
  {
    "name": "Mathias",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#bbbbbb",
      "textSecondary": "#7e7e7e",
      "textMuted": "#737373",
      "primary": "#c48dff",
      "primaryHover": "#5555ff",
      "primaryLight": "#f7c0ff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#67d9f0",
      "secondaryHover": "#55ffff",
      "accent": "#e52222",
      "accentHover": "#ff5555",
      "success": "#a6e32d",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#bbbbbb",
      "#e52222",
      "#a6e32d",
      "#fc951e",
      "#c48dff",
      "#67d9f0",
      "#545454"
    ],
    "id": "mathias"
  },
  {
    "name": "Mayukai",
    "isDark": true,
    "colors": {
      "background": "#1b1c24",
      "surface": "#2f3038",
      "surfaceHover": "#44454d",
      "surfaceElevated": "#3a3b43",
      "text": "#cbccc6",
      "textSecondary": "#989898",
      "textMuted": "#929290",
      "primary": "#95e6cb",
      "primaryHover": "#95e6cb",
      "primaryLight": "#c8fffe",
      "primarySubtle": "#3a3b43",
      "secondary": "#95e6cb",
      "secondaryHover": "#95e6cb",
      "accent": "#ed8274",
      "accentHover": "#f28779",
      "success": "#a6cc70",
      "border": "#5b5c64",
      "borderSubtle": "#41424a",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1b1c24",
      "#cbccc6",
      "#ed8274",
      "#a6cc70",
      "#fad07b",
      "#95e6cb",
      "#95e6cb",
      "#686868"
    ],
    "id": "mayukai"
  },
  {
    "name": "Midsummer Night",
    "isDark": true,
    "colors": {
      "background": "#1c1e26",
      "surface": "#30323a",
      "surfaceHover": "#45474f",
      "surfaceElevated": "#3b3d45",
      "text": "#c6b8b1",
      "textSecondary": "#9c9c9c",
      "textMuted": "#989492",
      "primary": "#35a5bb",
      "primaryHover": "#35a5bb",
      "primaryLight": "#68d8ee",
      "primarySubtle": "#3b3d45",
      "secondary": "#2dcbbe",
      "secondaryHover": "#2dcbbe",
      "accent": "#d85069",
      "accentHover": "#d85069",
      "success": "#2dcbbe",
      "border": "#5c5e66",
      "borderSubtle": "#42444c",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1c1e26",
      "#c6b8b1",
      "#d85069",
      "#2dcbbe",
      "#e5a382",
      "#35a5bb",
      "#2dcbbe",
      "#666666"
    ],
    "id": "midsummer-night"
  },
  {
    "name": "Min Dark",
    "isDark": true,
    "colors": {
      "background": "#1f1f1f",
      "surface": "#333333",
      "surfaceHover": "#484848",
      "surfaceElevated": "#3e3e3e",
      "text": "#f8f8f8",
      "textSecondary": "#9b9b9b",
      "textMuted": "#949494",
      "primary": "#79b8ff",
      "primaryHover": "#b392f0",
      "primaryLight": "#acebff",
      "primarySubtle": "#3e3e3e",
      "secondary": "#9db1c5",
      "secondaryHover": "#79b8ff",
      "accent": "#f97583",
      "accentHover": "#ff7a84",
      "success": "#85e89d",
      "border": "#5f5f5f",
      "borderSubtle": "#454545",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1f1f1f",
      "#f8f8f8",
      "#f97583",
      "#85e89d",
      "#ffab70",
      "#79b8ff",
      "#9db1c5",
      "#5c5c5c"
    ],
    "id": "min-dark"
  },
  {
    "name": "Mishran",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#bebebe",
      "textSecondary": "#7f7f7f",
      "textMuted": "#909090",
      "primary": "#96cbfe",
      "primaryHover": "#b5dcfe",
      "primaryLight": "#c9feff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#c6c5fe",
      "secondaryHover": "#dfdffe",
      "accent": "#ff6c60",
      "accentHover": "#ffb6b0",
      "success": "#a8ff60",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#bebebe",
      "#ff6c60",
      "#a8ff60",
      "#ffffb6",
      "#96cbfe",
      "#c6c5fe",
      "#7c7c7c"
    ],
    "id": "mishran"
  },
  {
    "name": "Modus Operandi",
    "isDark": false,
    "colors": {
      "background": "#ffffff",
      "surface": "#f7f7f7",
      "surfaceHover": "#ebebeb",
      "surfaceElevated": "#fafafa",
      "text": "#000000",
      "textSecondary": "#595959",
      "textMuted": "#3e3e3e",
      "primary": "#0031a9",
      "primaryHover": "#000b83",
      "primaryLight": "#4d7ef6",
      "primarySubtle": "#f2f2f2",
      "secondary": "#005e8b",
      "secondaryHover": "#003865",
      "accent": "#a60000",
      "accentHover": "#800000",
      "success": "#006800",
      "border": "#d9d9d9",
      "borderSubtle": "#ebebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ffffff",
      "#000000",
      "#a60000",
      "#006800",
      "#6f5500",
      "#0031a9",
      "#005e8b",
      "#595959"
    ],
    "id": "modus-operandi"
  },
  {
    "name": "Modus Operandi Tinted",
    "isDark": false,
    "colors": {
      "background": "#fbf7f0",
      "surface": "#f3efe8",
      "surfaceHover": "#e7e3dc",
      "surfaceElevated": "#f6f2eb",
      "text": "#000000",
      "textSecondary": "#595959",
      "textMuted": "#3e3e3e",
      "primary": "#0031a9",
      "primaryHover": "#000b83",
      "primaryLight": "#4d7ef6",
      "primarySubtle": "#eeeae3",
      "secondary": "#005e8b",
      "secondaryHover": "#003865",
      "accent": "#a60000",
      "accentHover": "#800000",
      "success": "#006800",
      "border": "#d5d1ca",
      "borderSubtle": "#e7e3dc",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#fbf7f0",
      "#000000",
      "#a60000",
      "#006800",
      "#6f5500",
      "#0031a9",
      "#005e8b",
      "#595959"
    ],
    "id": "modus-operandi-tinted"
  },
  {
    "name": "Modus Vivendi",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#ffffff",
      "textSecondary": "#808080",
      "textMuted": "#8b8b8b",
      "primary": "#2fafff",
      "primaryHover": "#79a8ff",
      "primaryLight": "#62e2ff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#00d3d0",
      "secondaryHover": "#6ae4b9",
      "accent": "#ff5f59",
      "accentHover": "#ff7f9f",
      "success": "#44bc44",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#ffffff",
      "#ff5f59",
      "#44bc44",
      "#d0bc00",
      "#2fafff",
      "#00d3d0",
      "#595959"
    ],
    "id": "modus-vivendi"
  },
  {
    "name": "Modus Vivendi Tinted",
    "isDark": true,
    "colors": {
      "background": "#0d0e1c",
      "surface": "#212230",
      "surfaceHover": "#363745",
      "surfaceElevated": "#2c2d3b",
      "text": "#ffffff",
      "textSecondary": "#8c8c8c",
      "textMuted": "#8b8b8b",
      "primary": "#2fafff",
      "primaryHover": "#79a8ff",
      "primaryLight": "#62e2ff",
      "primarySubtle": "#2c2d3b",
      "secondary": "#00d3d0",
      "secondaryHover": "#6ae4b9",
      "accent": "#ff5f59",
      "accentHover": "#ff6b55",
      "success": "#44bc44",
      "border": "#4d4e5c",
      "borderSubtle": "#333442",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0d0e1c",
      "#ffffff",
      "#ff5f59",
      "#44bc44",
      "#d0bc00",
      "#2fafff",
      "#00d3d0",
      "#595959"
    ],
    "id": "modus-vivendi-tinted"
  },
  {
    "name": "Molokai",
    "isDark": true,
    "colors": {
      "background": "#121212",
      "surface": "#262626",
      "surfaceHover": "#3b3b3b",
      "surfaceElevated": "#313131",
      "text": "#bbbbbb",
      "textSecondary": "#8d8d8d",
      "textMuted": "#858585",
      "primary": "#0f7fcf",
      "primaryHover": "#00afff",
      "primaryLight": "#42b2ff",
      "primarySubtle": "#313131",
      "secondary": "#42a7cf",
      "secondaryHover": "#50cdfe",
      "accent": "#fa2573",
      "accentHover": "#f5669c",
      "success": "#97e123",
      "border": "#525252",
      "borderSubtle": "#383838",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#121212",
      "#bbbbbb",
      "#fa2573",
      "#97e123",
      "#dfd460",
      "#0f7fcf",
      "#42a7cf",
      "#545454"
    ],
    "id": "molokai"
  },
  {
    "name": "Monokai",
    "isDark": true,
    "colors": {
      "background": "#272822",
      "surface": "#3b3c36",
      "surfaceHover": "#50514b",
      "surfaceElevated": "#464741",
      "text": "#f8f8f2",
      "textSecondary": "#aba794",
      "textMuted": "#a2a090",
      "primary": "#66d9ef",
      "primaryHover": "#66d9ef",
      "primaryLight": "#99ffff",
      "primarySubtle": "#464741",
      "secondary": "#ae81ff",
      "secondaryHover": "#ae81ff",
      "accent": "#f92672",
      "accentHover": "#f92672",
      "success": "#a6e22e",
      "border": "#676862",
      "borderSubtle": "#4d4e48",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#272822",
      "#f8f8f2",
      "#f92672",
      "#a6e22e",
      "#e6db74",
      "#66d9ef",
      "#ae81ff",
      "#75715e"
    ],
    "id": "monokai"
  },
  {
    "name": "Monokai Soda",
    "isDark": true,
    "colors": {
      "background": "#191919",
      "surface": "#2d2d2d",
      "surfaceHover": "#424242",
      "surfaceElevated": "#383838",
      "text": "#c4c4b5",
      "textSecondary": "#979481",
      "textMuted": "#918f7d",
      "primary": "#9c64fe",
      "primaryHover": "#9c64fe",
      "primaryLight": "#cf97ff",
      "primarySubtle": "#383838",
      "secondary": "#57d1ea",
      "secondaryHover": "#57d1ea",
      "accent": "#f3005f",
      "accentHover": "#f3005f",
      "success": "#97e023",
      "border": "#595959",
      "borderSubtle": "#3f3f3f",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#191919",
      "#c4c4b5",
      "#f3005f",
      "#97e023",
      "#fa8419",
      "#9c64fe",
      "#57d1ea",
      "#615e4b"
    ],
    "id": "monokai-soda"
  },
  {
    "name": "moonlight",
    "isDark": true,
    "colors": {
      "background": "#212337",
      "surface": "#35374b",
      "surfaceHover": "#4a4c60",
      "surfaceElevated": "#404256",
      "text": "#e4f3fa",
      "textSecondary": "#a3a3a3",
      "textMuted": "#979c9e",
      "primary": "#04d1f9",
      "primaryHover": "#2ddbfc",
      "primaryLight": "#37ffff",
      "primarySubtle": "#404256",
      "secondary": "#b994f1",
      "secondaryHover": "#bf9ef0",
      "accent": "#ff757f",
      "accentHover": "#f78b92",
      "success": "#2df4c0",
      "border": "#616377",
      "borderSubtle": "#47495d",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#212337",
      "#e4f3fa",
      "#ff757f",
      "#2df4c0",
      "#ffc777",
      "#04d1f9",
      "#b994f1",
      "#767676"
    ],
    "id": "moonlight"
  },
  {
    "name": "Neowave",
    "isDark": true,
    "colors": {
      "background": "#161021",
      "surface": "#2a2435",
      "surfaceHover": "#3f394a",
      "surfaceElevated": "#352f40",
      "text": "#00ffff",
      "textSecondary": "#498eef",
      "textMuted": "#1490d4",
      "primary": "#00ff00",
      "primaryHover": "#00ff00",
      "primaryLight": "#33ff33",
      "primarySubtle": "#352f40",
      "secondary": "#0afdf6",
      "secondaryHover": "#0afdf6",
      "accent": "#ff0000",
      "accentHover": "#ff0000",
      "success": "#df00df",
      "border": "#565061",
      "borderSubtle": "#3c3647",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#161021",
      "#00ffff",
      "#ff0000",
      "#df00df",
      "#ff7f00",
      "#00ff00",
      "#0afdf6",
      "#1c61c2"
    ],
    "id": "neowave"
  },
  {
    "name": "Night Owl",
    "isDark": true,
    "colors": {
      "background": "#011627",
      "surface": "#152a3b",
      "surfaceHover": "#2a3f50",
      "surfaceElevated": "#203546",
      "text": "#d6deeb",
      "textSecondary": "#908f8f",
      "textMuted": "#86888c",
      "primary": "#82aaff",
      "primaryHover": "#82aaff",
      "primaryLight": "#b5ddff",
      "primarySubtle": "#203546",
      "secondary": "#21c7a8",
      "secondaryHover": "#7fdbca",
      "accent": "#ef5350",
      "accentHover": "#ef5350",
      "success": "#22da6e",
      "border": "#415667",
      "borderSubtle": "#273c4d",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#011627",
      "#d6deeb",
      "#ef5350",
      "#22da6e",
      "#addb67",
      "#82aaff",
      "#21c7a8",
      "#575656"
    ],
    "id": "night-owl"
  },
  {
    "name": "Nightfly",
    "isDark": true,
    "colors": {
      "background": "#011627",
      "surface": "#152a3b",
      "surfaceHover": "#2a3f50",
      "surfaceElevated": "#203546",
      "text": "#acb4c2",
      "textSecondary": "#7f9292",
      "textMuted": "#8a9a9e",
      "primary": "#82aaff",
      "primaryHover": "#82aaff",
      "primaryLight": "#b5ddff",
      "primarySubtle": "#203546",
      "secondary": "#7fdbca",
      "secondaryHover": "#7fdbca",
      "accent": "#fc514e",
      "accentHover": "#ff5874",
      "success": "#a1cd5e",
      "border": "#415667",
      "borderSubtle": "#273c4d",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#011627",
      "#acb4c2",
      "#fc514e",
      "#a1cd5e",
      "#e3d18a",
      "#82aaff",
      "#7fdbca",
      "#7c8f8f"
    ],
    "id": "nightfly"
  },
  {
    "name": "NightLion v1",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#bbbbbb",
      "textSecondary": "#7e7e7e",
      "textMuted": "#737373",
      "primary": "#266ad7",
      "primaryHover": "#5555ff",
      "primaryLight": "#599dff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#00d9df",
      "secondaryHover": "#55ffff",
      "accent": "#bb0000",
      "accentHover": "#ff5555",
      "success": "#5ede8f",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#bbbbbb",
      "#bb0000",
      "#5ede8f",
      "#f2f067",
      "#266ad7",
      "#00d9df",
      "#545454"
    ],
    "id": "nightlion-v1"
  },
  {
    "name": "noirblaze",
    "isDark": true,
    "colors": {
      "background": "#121212",
      "surface": "#262626",
      "surfaceHover": "#3b3b3b",
      "surfaceElevated": "#313131",
      "text": "#d5d5d5",
      "textSecondary": "#8e8e8e",
      "textMuted": "#909090",
      "primary": "#b0b0b0",
      "primaryHover": "#bebebe",
      "primaryLight": "#e3e3e3",
      "primarySubtle": "#313131",
      "secondary": "#787878",
      "secondaryHover": "#919191",
      "accent": "#ff0088",
      "accentHover": "#fd319e",
      "success": "#00ff77",
      "border": "#525252",
      "borderSubtle": "#383838",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#121212",
      "#d5d5d5",
      "#ff0088",
      "#00ff77",
      "#ffffff",
      "#b0b0b0",
      "#787878",
      "#737373"
    ],
    "id": "noirblaze"
  },
  {
    "name": "noirbuddy-oxide",
    "isDark": true,
    "colors": {
      "background": "#070e11",
      "surface": "#1b2225",
      "surfaceHover": "#30373a",
      "surfaceElevated": "#262d30",
      "text": "#d5d5d5",
      "textSecondary": "#888888",
      "textMuted": "#909090",
      "primary": "#b0b0b0",
      "primaryHover": "#bebebe",
      "primaryLight": "#e3e3e3",
      "primarySubtle": "#262d30",
      "secondary": "#787878",
      "secondaryHover": "#919191",
      "accent": "#fa5e86",
      "accentHover": "#ff0088",
      "success": "#00d992",
      "border": "#474e51",
      "borderSubtle": "#2d3437",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#070e11",
      "#d5d5d5",
      "#fa5e86",
      "#00d992",
      "#ffffff",
      "#b0b0b0",
      "#787878",
      "#737373"
    ],
    "id": "noirbuddy-oxide"
  },
  {
    "name": "Novel",
    "isDark": false,
    "colors": {
      "background": "#dfdbc3",
      "surface": "#d7d3bb",
      "surfaceHover": "#cbc7af",
      "surfaceElevated": "#dad6be",
      "text": "#3b2322",
      "textSecondary": "#5b5b5b",
      "textMuted": "#6b6363",
      "primary": "#0000cc",
      "primaryHover": "#0000a6",
      "primaryLight": "#4d4dff",
      "primarySubtle": "#d2ceb6",
      "secondary": "#0087cc",
      "secondaryHover": "#0061a6",
      "accent": "#cc0000",
      "accentHover": "#a60000",
      "success": "#009600",
      "border": "#b9b59d",
      "borderSubtle": "#cbc7af",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#dfdbc3",
      "#3b2322",
      "#cc0000",
      "#009600",
      "#d06b00",
      "#0000cc",
      "#0087cc",
      "#7f7f7f"
    ],
    "id": "novel"
  },
  {
    "name": "One Half Dark",
    "isDark": true,
    "colors": {
      "background": "#282c34",
      "surface": "#3c4048",
      "surfaceHover": "#51555d",
      "surfaceElevated": "#474b53",
      "text": "#dcdfe4",
      "textSecondary": "#a2acbf",
      "textMuted": "#9ea6b5",
      "primary": "#61afef",
      "primaryHover": "#61afef",
      "primaryLight": "#94e2ff",
      "primarySubtle": "#474b53",
      "secondary": "#56b6c2",
      "secondaryHover": "#56b6c2",
      "accent": "#e06c75",
      "accentHover": "#e06c75",
      "success": "#98c379",
      "border": "#686c74",
      "borderSubtle": "#4e525a",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#282c34",
      "#dcdfe4",
      "#e06c75",
      "#98c379",
      "#e5c07b",
      "#61afef",
      "#56b6c2",
      "#5d677a"
    ],
    "id": "onehalfdark"
  },
  {
    "name": "One Half Light",
    "isDark": false,
    "colors": {
      "background": "#fafafa",
      "surface": "#f2f2f2",
      "surfaceHover": "#e6e6e6",
      "surfaceElevated": "#f5f5f5",
      "text": "#383a42",
      "textSecondary": "#383a42",
      "textMuted": "#383a42",
      "primary": "#0184bc",
      "primaryHover": "#005e96",
      "primaryLight": "#4ed1ff",
      "primarySubtle": "#ededed",
      "secondary": "#0997b3",
      "secondaryHover": "#00718d",
      "accent": "#e45649",
      "accentHover": "#be3023",
      "success": "#40a14f",
      "border": "#d4d4d4",
      "borderSubtle": "#e6e6e6",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#fafafa",
      "#383a42",
      "#e45649",
      "#40a14f",
      "#c18401",
      "#0184bc",
      "#0997b3",
      "#383a42"
    ],
    "id": "onehalflight"
  },
  {
    "name": "Osaka Jade",
    "isDark": true,
    "colors": {
      "background": "#111c18",
      "surface": "#25302c",
      "surfaceHover": "#3a4541",
      "surfaceElevated": "#303b37",
      "text": "#c1c497",
      "textSecondary": "#869b8e",
      "textMuted": "#83937c",
      "primary": "#509475",
      "primaryHover": "#acd4cf",
      "primaryLight": "#83c7a8",
      "primarySubtle": "#303b37",
      "secondary": "#2dd5b7",
      "secondaryHover": "#8cd3cb",
      "accent": "#ff5345",
      "accentHover": "#db9f9c",
      "success": "#549e6a",
      "border": "#515c58",
      "borderSubtle": "#37423e",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#111c18",
      "#c1c497",
      "#ff5345",
      "#549e6a",
      "#459451",
      "#509475",
      "#2dd5b7",
      "#53685b"
    ],
    "id": "osaka-jade"
  },
  {
    "name": "PaperColor Dark",
    "isDark": true,
    "colors": {
      "background": "#1c1c1c",
      "surface": "#303030",
      "surfaceHover": "#454545",
      "surfaceElevated": "#3b3b3b",
      "text": "#d0d0d0",
      "textSecondary": "#979797",
      "textMuted": "#919191",
      "primary": "#5fafd7",
      "primaryHover": "#ffaf00",
      "primaryLight": "#92e2ff",
      "primarySubtle": "#3b3b3b",
      "secondary": "#d7875f",
      "secondaryHover": "#00afaf",
      "accent": "#af005f",
      "accentHover": "#5faf5f",
      "success": "#5faf00",
      "border": "#5c5c5c",
      "borderSubtle": "#424242",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1c1c1c",
      "#d0d0d0",
      "#af005f",
      "#5faf00",
      "#d7af5f",
      "#5fafd7",
      "#d7875f",
      "#585858"
    ],
    "id": "papercolor-dark"
  },
  {
    "name": "PaulMillr",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#f1f1f1",
      "textSecondary": "#7e7e7e",
      "textMuted": "#909090",
      "primary": "#396ad6",
      "primaryHover": "#7099ec",
      "primaryLight": "#6c9dff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#66ccff",
      "secondaryHover": "#79def1",
      "accent": "#ff0000",
      "accentHover": "#ff007f",
      "success": "#78ff0e",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#f1f1f1",
      "#ff0000",
      "#78ff0e",
      "#e6be00",
      "#396ad6",
      "#66ccff",
      "#666666"
    ],
    "id": "paulmillr"
  },
  {
    "name": "PencilLight",
    "isDark": false,
    "colors": {
      "background": "#f0f0f0",
      "surface": "#e8e8e8",
      "surfaceHover": "#dcdcdc",
      "surfaceElevated": "#ebebeb",
      "text": "#414141",
      "textSecondary": "#414141",
      "textMuted": "#414141",
      "primary": "#008ec4",
      "primaryHover": "#00689e",
      "primaryLight": "#4ddbff",
      "primarySubtle": "#e3e3e3",
      "secondary": "#20a4b9",
      "secondaryHover": "#007e93",
      "accent": "#c30670",
      "accentHover": "#9d004a",
      "success": "#10a778",
      "border": "#cacaca",
      "borderSubtle": "#dcdcdc",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#f0f0f0",
      "#414141",
      "#c30670",
      "#10a778",
      "#a79c14",
      "#008ec4",
      "#20a4b9",
      "#414141"
    ],
    "id": "pencillight"
  },
  {
    "name": "Piatto Light",
    "isDark": false,
    "colors": {
      "background": "#ffffff",
      "surface": "#f7f7f7",
      "surfaceHover": "#ebebeb",
      "surfaceElevated": "#fafafa",
      "text": "#414141",
      "textSecondary": "#3e3e3e",
      "textMuted": "#3f3f3f",
      "primary": "#3b5ea7",
      "primaryHover": "#153881",
      "primaryLight": "#88abf4",
      "primarySubtle": "#f2f2f2",
      "secondary": "#66781d",
      "secondaryHover": "#405200",
      "accent": "#b23670",
      "accentHover": "#8c104a",
      "success": "#66781d",
      "border": "#d9d9d9",
      "borderSubtle": "#ebebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ffffff",
      "#414141",
      "#b23670",
      "#66781d",
      "#cc6e33",
      "#3b5ea7",
      "#66781d",
      "#3e3e3e"
    ],
    "id": "piatto-light"
  },
  {
    "name": "pink lavender",
    "isDark": true,
    "colors": {
      "background": "#0c0611",
      "surface": "#201a25",
      "surfaceHover": "#352f3a",
      "surfaceElevated": "#2b2530",
      "text": "#eed8e5",
      "textSecondary": "#997e96",
      "textMuted": "#ac93a7",
      "primary": "#a697a0",
      "primaryHover": "#90758d",
      "primaryLight": "#d9cad3",
      "primarySubtle": "#2b2530",
      "secondary": "#c8a3bc",
      "secondaryHover": "#bb9fc2",
      "accent": "#b292ac",
      "accentHover": "#c29eb6",
      "success": "#c8a3bc",
      "border": "#4c4651",
      "borderSubtle": "#322c37",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0c0611",
      "#eed8e5",
      "#b292ac",
      "#c8a3bc",
      "#dab2cc",
      "#a697a0",
      "#c8a3bc",
      "#90758d"
    ],
    "id": "pink-lavender"
  },
  {
    "name": "Popping and Locking",
    "isDark": true,
    "colors": {
      "background": "#181921",
      "surface": "#2c2d35",
      "surfaceHover": "#41424a",
      "surfaceElevated": "#373840",
      "text": "#ebdbb2",
      "textSecondary": "#a19283",
      "textMuted": "#ad9d87",
      "primary": "#458588",
      "primaryHover": "#99c6ca",
      "primaryLight": "#78b8bb",
      "primarySubtle": "#373840",
      "secondary": "#689d6a",
      "secondaryHover": "#7ec16e",
      "accent": "#cc241d",
      "accentHover": "#f42c3e",
      "success": "#98971a",
      "border": "#585961",
      "borderSubtle": "#3e3f47",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#181921",
      "#ebdbb2",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#689d6a",
      "#928374"
    ],
    "id": "poppingandlocking"
  },
  {
    "name": "Rippedcasts",
    "isDark": true,
    "colors": {
      "background": "#2b2b2b",
      "surface": "#3f3f3f",
      "surfaceHover": "#545454",
      "surfaceElevated": "#4a4a4a",
      "text": "#ffffff",
      "textSecondary": "#ababab",
      "textMuted": "#a3a3a3",
      "primary": "#74a4af",
      "primaryHover": "#86bdc8",
      "primaryLight": "#a7d7e2",
      "primarySubtle": "#4a4a4a",
      "secondary": "#5a637e",
      "secondaryHover": "#8b9bc4",
      "accent": "#ccae95",
      "accentHover": "#edcbac",
      "success": "#a7ff60",
      "border": "#6b6b6b",
      "borderSubtle": "#515151",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#2b2b2b",
      "#ffffff",
      "#ccae95",
      "#a7ff60",
      "#beba1f",
      "#74a4af",
      "#5a637e",
      "#666666"
    ],
    "id": "rippedcasts"
  },
  {
    "name": "Rosé Pine",
    "isDark": true,
    "colors": {
      "background": "#191724",
      "surface": "#2d2b38",
      "surfaceHover": "#42404d",
      "surfaceElevated": "#383643",
      "text": "#e0def4",
      "textSecondary": "#9591ad",
      "textMuted": "#908da7",
      "primary": "#9ccfd8",
      "primaryHover": "#9ccfd8",
      "primaryLight": "#cfffff",
      "primarySubtle": "#383643",
      "secondary": "#ebbcba",
      "secondaryHover": "#ebbcba",
      "accent": "#eb6f92",
      "accentHover": "#eb6f92",
      "success": "#31748f",
      "border": "#595764",
      "borderSubtle": "#3f3d4a",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#191724",
      "#e0def4",
      "#eb6f92",
      "#31748f",
      "#f6c177",
      "#9ccfd8",
      "#ebbcba",
      "#6e6a86"
    ],
    "id": "rose-pine"
  },
  {
    "name": "Rosé Pine Moon",
    "isDark": true,
    "colors": {
      "background": "#232136",
      "surface": "#37354a",
      "surfaceHover": "#4c4a5f",
      "surfaceElevated": "#424055",
      "text": "#e0def4",
      "textSecondary": "#a19db9",
      "textMuted": "#9c99b3",
      "primary": "#9ccfd8",
      "primaryHover": "#9ccfd8",
      "primaryLight": "#cfffff",
      "primarySubtle": "#424055",
      "secondary": "#ea9a97",
      "secondaryHover": "#ea9a97",
      "accent": "#eb6f92",
      "accentHover": "#eb6f92",
      "success": "#3e8fb0",
      "border": "#636176",
      "borderSubtle": "#49475c",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#232136",
      "#e0def4",
      "#eb6f92",
      "#3e8fb0",
      "#f6c177",
      "#9ccfd8",
      "#ea9a97",
      "#6e6a86"
    ],
    "id": "rose-pine-moon"
  },
  {
    "name": "shadotheme",
    "isDark": true,
    "colors": {
      "background": "#191724",
      "surface": "#2d2b38",
      "surfaceHover": "#42404d",
      "surfaceElevated": "#383643",
      "text": "#e3c7fc",
      "textSecondary": "#ab8c9f",
      "textMuted": "#ba9cb9",
      "primary": "#bd93f9",
      "primaryHover": "#bd93f9",
      "primaryLight": "#f0c6ff",
      "primarySubtle": "#383643",
      "secondary": "#f18fb0",
      "secondaryHover": "#f18fb0",
      "accent": "#b52a5b",
      "accentHover": "#b52a5b",
      "success": "#ff4971",
      "border": "#595764",
      "borderSubtle": "#3f3d4a",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#191724",
      "#e3c7fc",
      "#b52a5b",
      "#ff4971",
      "#8897f4",
      "#bd93f9",
      "#f18fb0",
      "#a8899c"
    ],
    "id": "shadotheme"
  },
  {
    "name": "Sierra",
    "isDark": true,
    "colors": {
      "background": "#1c1a14",
      "surface": "#302e28",
      "surfaceHover": "#45433d",
      "surfaceElevated": "#3b3933",
      "text": "#cacbb9",
      "textSecondary": "#cc8281",
      "textMuted": "#b5827c",
      "primary": "#989876",
      "primaryHover": "#98984e",
      "primaryLight": "#cbcba9",
      "primarySubtle": "#3b3933",
      "secondary": "#a18e60",
      "secondaryHover": "#a17140",
      "accent": "#515a45",
      "accentHover": "#475a2e",
      "success": "#68694f",
      "border": "#5c5a54",
      "borderSubtle": "#42403a",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1c1a14",
      "#cacbb9",
      "#515a45",
      "#68694f",
      "#7f7f60",
      "#989876",
      "#a18e60",
      "#a85e5d"
    ],
    "id": "sierra"
  },
  {
    "name": "Slate",
    "isDark": true,
    "colors": {
      "background": "#212121",
      "surface": "#353535",
      "surfaceHover": "#4a4a4a",
      "surfaceElevated": "#404040",
      "text": "#4cc8ea",
      "textSecondary": "#ffffff",
      "textMuted": "#c2e7f2",
      "primary": "#618685",
      "primaryHover": "#79afd2",
      "primaryLight": "#587d7c",
      "primarySubtle": "#404040",
      "secondary": "#14ab9c",
      "secondaryHover": "#8bdee0",
      "accent": "#e1a7bf",
      "accentHover": "#ffccd8",
      "success": "#80d778",
      "border": "#616161",
      "borderSubtle": "#474747",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#212121",
      "#34b0d2",
      "#e1a7bf",
      "#80d778",
      "#c4c9bf",
      "#254a49",
      "#14ab9c",
      "#ffffff"
    ],
    "id": "slate"
  },
  {
    "name": "Smyck",
    "isDark": true,
    "colors": {
      "background": "#1b1b1b",
      "surface": "#2f2f2f",
      "surfaceHover": "#444444",
      "surfaceElevated": "#3a3a3a",
      "text": "#f7f7f7",
      "textSecondary": "#989898",
      "textMuted": "#a0a0a0",
      "primary": "#62a3c4",
      "primaryHover": "#8dcff0",
      "primaryLight": "#95d6f7",
      "primarySubtle": "#3a3a3a",
      "secondary": "#207383",
      "secondaryHover": "#69d9cf",
      "accent": "#b74131",
      "accentHover": "#d6837b",
      "success": "#7da900",
      "border": "#5b5b5b",
      "borderSubtle": "#414141",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1b1b1b",
      "#f7f7f7",
      "#b74131",
      "#7da900",
      "#c4a400",
      "#62a3c4",
      "#207383",
      "#7a7a7a"
    ],
    "id": "smyck"
  },
  {
    "name": "snazzy",
    "isDark": true,
    "colors": {
      "background": "#282a36",
      "surface": "#3c3e4a",
      "surfaceHover": "#51535f",
      "surfaceElevated": "#474955",
      "text": "#eff0eb",
      "textSecondary": "#aaaaaa",
      "textMuted": "#a3a3a1",
      "primary": "#57c7ff",
      "primaryHover": "#57c7ff",
      "primaryLight": "#8afaff",
      "primarySubtle": "#474955",
      "secondary": "#9aedfe",
      "secondaryHover": "#9aedfe",
      "accent": "#ff5c57",
      "accentHover": "#ff5c57",
      "success": "#5af78e",
      "border": "#686a76",
      "borderSubtle": "#4e505c",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#282a36",
      "#eff0eb",
      "#ff5c57",
      "#5af78e",
      "#f3f99d",
      "#57c7ff",
      "#9aedfe",
      "#686868"
    ],
    "id": "snazzy"
  },
  {
    "name": "SnowLight",
    "isDark": false,
    "colors": {
      "background": "#fbffff",
      "surface": "#f3f7f7",
      "surfaceHover": "#e7ebeb",
      "surfaceElevated": "#f6fafa",
      "text": "#535c65",
      "textSecondary": "#67717c",
      "textMuted": "#656f79",
      "primary": "#2b7ab2",
      "primaryHover": "#05548c",
      "primaryLight": "#78c7ff",
      "primarySubtle": "#eef2f2",
      "secondary": "#008483",
      "secondaryHover": "#005e5d",
      "accent": "#ae5865",
      "accentHover": "#88323f",
      "success": "#4d7f43",
      "border": "#d5d9d9",
      "borderSubtle": "#e7ebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#fbffff",
      "#535c65",
      "#ae5865",
      "#4d7f43",
      "#906c33",
      "#2b7ab2",
      "#008483",
      "#6d7782"
    ],
    "id": "snowlight"
  },
  {
    "name": "Sonokai Sushia",
    "isDark": true,
    "colors": {
      "background": "#2d2a2e",
      "surface": "#413e42",
      "surfaceHover": "#565357",
      "surfaceElevated": "#4c494d",
      "text": "#e3e1e4",
      "textSecondary": "#aeaab3",
      "textMuted": "#a7a3aa",
      "primary": "#7accd7",
      "primaryHover": "#7accd7",
      "primaryLight": "#adffff",
      "primarySubtle": "#4c494d",
      "secondary": "#ef9062",
      "secondaryHover": "#ef9062",
      "accent": "#f85e84",
      "accentHover": "#f85e84",
      "success": "#9ecd6f",
      "border": "#6d6a6e",
      "borderSubtle": "#535054",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#2d2a2e",
      "#e3e1e4",
      "#f85e84",
      "#9ecd6f",
      "#e5c463",
      "#7accd7",
      "#ef9062",
      "#848089"
    ],
    "id": "sonokai-sushia"
  },
  {
    "name": "spaceduck",
    "isDark": true,
    "colors": {
      "background": "#0f111b",
      "surface": "#23252f",
      "surfaceHover": "#383a44",
      "surfaceElevated": "#2e303a",
      "text": "#ecf0c1",
      "textSecondary": "#838ab5",
      "textMuted": "#9096a6",
      "primary": "#00a3cc",
      "primaryHover": "#00a3cc",
      "primaryLight": "#33d6ff",
      "primarySubtle": "#2e303a",
      "secondary": "#7a5ccc",
      "secondaryHover": "#7a5ccc",
      "accent": "#e33400",
      "accentHover": "#e33400",
      "success": "#5ccc96",
      "border": "#4f515b",
      "borderSubtle": "#353741",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#0f111b",
      "#ecf0c1",
      "#e33400",
      "#5ccc96",
      "#b3a1e6",
      "#00a3cc",
      "#7a5ccc",
      "#686f9a"
    ],
    "id": "spaceduck"
  },
  {
    "name": "Spring",
    "isDark": false,
    "colors": {
      "background": "#ffffff",
      "surface": "#f7f7f7",
      "surfaceHover": "#ebebeb",
      "surfaceElevated": "#fafafa",
      "text": "#4d4d4c",
      "textSecondary": "#000000",
      "textMuted": "#171717",
      "primary": "#009cb8",
      "primaryHover": "#00acc8",
      "primaryLight": "#69ffff",
      "primarySubtle": "#f2f2f2",
      "secondary": "#3e999f",
      "secondaryHover": "#187379",
      "accent": "#ff4c83",
      "accentHover": "#d9265d",
      "success": "#1f8c3a",
      "border": "#d9d9d9",
      "borderSubtle": "#ebebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ffffff",
      "#4d4d4c",
      "#ff4c83",
      "#1f8c3a",
      "#1fc95a",
      "#1cd2ee",
      "#3e999f",
      "#000000"
    ],
    "id": "spring"
  },
  {
    "name": "srcery",
    "isDark": true,
    "colors": {
      "background": "#1c1b19",
      "surface": "#302f2d",
      "surfaceHover": "#454442",
      "surfaceElevated": "#3b3a38",
      "text": "#fce8c3",
      "textSecondary": "#a39387",
      "textMuted": "#b1a08c",
      "primary": "#2f7bc2",
      "primaryHover": "#68a8e4",
      "primaryLight": "#5fabf2",
      "primarySubtle": "#3b3a38",
      "secondary": "#0aaeb3",
      "secondaryHover": "#2be4d0",
      "accent": "#ef2f27",
      "accentHover": "#f75341",
      "success": "#519f50",
      "border": "#5c5b59",
      "borderSubtle": "#42413f",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1c1b19",
      "#fce8c3",
      "#ef2f27",
      "#519f50",
      "#fbb829",
      "#2c78bf",
      "#0aaeb3",
      "#918175"
    ],
    "id": "srcery"
  },
  {
    "name": "Substrata",
    "isDark": true,
    "colors": {
      "background": "#191c25",
      "surface": "#2d3039",
      "surfaceHover": "#42454e",
      "surfaceElevated": "#383b44",
      "text": "#b5b4c9",
      "textSecondary": "#9498aa",
      "textMuted": "#8e91a3",
      "primary": "#8296b0",
      "primaryHover": "#a0b9d8",
      "primaryLight": "#b5c9e3",
      "primarySubtle": "#383b44",
      "secondary": "#659ea2",
      "secondaryHover": "#7dc2c7",
      "accent": "#cf8164",
      "accentHover": "#fe9f7c",
      "success": "#76a065",
      "border": "#595c65",
      "borderSubtle": "#3f424b",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#191c25",
      "#b5b4c9",
      "#cf8164",
      "#76a065",
      "#ab924c",
      "#8296b0",
      "#659ea2",
      "#5b5f71"
    ],
    "id": "substrata"
  },
  {
    "name": "Tango Dark",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#ffffff",
      "textSecondary": "#7f817d",
      "textMuted": "#888987",
      "primary": "#3465a4",
      "primaryHover": "#729fcf",
      "primaryLight": "#6798d7",
      "primarySubtle": "#1f1f1f",
      "secondary": "#06989a",
      "secondaryHover": "#34e2e2",
      "accent": "#cc0000",
      "accentHover": "#ef2929",
      "success": "#4e9a06",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#ffffff",
      "#cc0000",
      "#4e9a06",
      "#c4a000",
      "#3465a4",
      "#06989a",
      "#555753"
    ],
    "id": "tango-dark"
  },
  {
    "name": "Tango Light",
    "isDark": false,
    "colors": {
      "background": "#ffffff",
      "surface": "#f7f7f7",
      "surfaceHover": "#ebebeb",
      "surfaceElevated": "#fafafa",
      "text": "#000000",
      "textSecondary": "#555753",
      "textMuted": "#3b3d3a",
      "primary": "#3465a4",
      "primaryHover": "#0e3f7e",
      "primaryLight": "#81b2f1",
      "primarySubtle": "#f2f2f2",
      "secondary": "#06989a",
      "secondaryHover": "#007274",
      "accent": "#cc0000",
      "accentHover": "#a60000",
      "success": "#4e9a06",
      "border": "#d9d9d9",
      "borderSubtle": "#ebebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ffffff",
      "#000000",
      "#cc0000",
      "#4e9a06",
      "#c4a000",
      "#3465a4",
      "#06989a",
      "#555753"
    ],
    "id": "tango-light"
  },
  {
    "name": "Tomorrow",
    "isDark": false,
    "colors": {
      "background": "#ffffff",
      "surface": "#f7f7f7",
      "surfaceHover": "#ebebeb",
      "surfaceElevated": "#fafafa",
      "text": "#4c4c4c",
      "textSecondary": "#000000",
      "textMuted": "#171717",
      "primary": "#4170ae",
      "primaryHover": "#1b4a88",
      "primaryLight": "#8ebdfb",
      "primarySubtle": "#f2f2f2",
      "secondary": "#3d999f",
      "secondaryHover": "#177379",
      "accent": "#c82828",
      "accentHover": "#a20202",
      "success": "#708b00",
      "border": "#d9d9d9",
      "borderSubtle": "#ebebeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ffffff",
      "#4c4c4c",
      "#c82828",
      "#708b00",
      "#e9b600",
      "#4170ae",
      "#3d999f",
      "#000000"
    ],
    "id": "tomorrow"
  },
  {
    "name": "Unikitty",
    "isDark": false,
    "colors": {
      "background": "#ef91d6",
      "surface": "#e789ce",
      "surfaceHover": "#db7dc2",
      "surfaceElevated": "#ea8cd1",
      "text": "#0b0a0b",
      "textSecondary": "#3d3c3d",
      "textMuted": "#323132",
      "primary": "#2051ba",
      "primaryHover": "#0637a0",
      "primaryLight": "#79aaff",
      "primarySubtle": "#e284c9",
      "secondary": "#85cfbc",
      "secondaryHover": "#5fa996",
      "accent": "#9a2426",
      "accentHover": "#740000",
      "success": "#c7fa97",
      "border": "#c96bb0",
      "borderSubtle": "#db7dc2",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#ef91d6",
      "#0b0a0b",
      "#9a2426",
      "#c7fa97",
      "#ebdf65",
      "#2c5dc6",
      "#85cfbc",
      "#434243"
    ],
    "id": "unikitty"
  },
  {
    "name": "Vague",
    "isDark": true,
    "colors": {
      "background": "#141415",
      "surface": "#282829",
      "surfaceHover": "#3d3d3e",
      "surfaceElevated": "#333334",
      "text": "#cdcdcd",
      "textSecondary": "#8d8da6",
      "textMuted": "#878798",
      "primary": "#6e94b2",
      "primaryHover": "#8ba9c1",
      "primaryLight": "#a1c7e5",
      "primarySubtle": "#333334",
      "secondary": "#aeaed1",
      "secondaryHover": "#bebeda",
      "accent": "#d8647e",
      "accentHover": "#e08398",
      "success": "#7fa563",
      "border": "#545455",
      "borderSubtle": "#3a3a3b",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#141415",
      "#cdcdcd",
      "#d8647e",
      "#7fa563",
      "#f3be7c",
      "#6e94b2",
      "#aeaed1",
      "#606079"
    ],
    "id": "vague"
  },
  {
    "name": "VibrantInk",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#ffffff",
      "textSecondary": "#7e7e7e",
      "textMuted": "#878787",
      "primary": "#44b3cc",
      "primaryHover": "#0000ff",
      "primaryLight": "#77e6ff",
      "primarySubtle": "#1f1f1f",
      "secondary": "#44b3cc",
      "secondaryHover": "#00ffff",
      "accent": "#ff6600",
      "accentHover": "#ff0000",
      "success": "#ccff04",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#ffffff",
      "#ff6600",
      "#ccff04",
      "#ffcc00",
      "#44b3cc",
      "#44b3cc",
      "#545454"
    ],
    "id": "vibrantink"
  },
  {
    "name": "VS Code Light Plus",
    "isDark": false,
    "colors": {
      "background": "#fffeff",
      "surface": "#f7f6f7",
      "surfaceHover": "#ebeaeb",
      "surfaceElevated": "#faf9fa",
      "text": "#333333",
      "textSecondary": "#666666",
      "textMuted": "#575757",
      "primary": "#0450a4",
      "primaryHover": "#002a7e",
      "primaryLight": "#519df1",
      "primarySubtle": "#f2f1f2",
      "secondary": "#0598bc",
      "secondaryHover": "#007296",
      "accent": "#af2a29",
      "accentHover": "#890403",
      "success": "#00bc00",
      "border": "#d9d8d9",
      "borderSubtle": "#ebeaeb",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#fffeff",
      "#333333",
      "#af2a29",
      "#00bc00",
      "#949800",
      "#0450a4",
      "#0598bc",
      "#666666"
    ],
    "id": "vs-code-light-plus"
  },
  {
    "name": "VSCode_Dark",
    "isDark": true,
    "colors": {
      "background": "#1e1e1e",
      "surface": "#323232",
      "surfaceHover": "#474747",
      "surfaceElevated": "#3d3d3d",
      "text": "#cccccc",
      "textSecondary": "#999999",
      "textMuted": "#949494",
      "primary": "#3b8eea",
      "primaryHover": "#2472c8",
      "primaryLight": "#6ec1ff",
      "primarySubtle": "#3d3d3d",
      "secondary": "#29b8db",
      "secondaryHover": "#11a8cd",
      "accent": "#f14c4c",
      "accentHover": "#cd3131",
      "success": "#23d18b",
      "border": "#5e5e5e",
      "borderSubtle": "#444444",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1e1e1e",
      "#cccccc",
      "#f14c4c",
      "#23d18b",
      "#f5f543",
      "#3b8eea",
      "#29b8db",
      "#666666"
    ],
    "id": "vscode-dark"
  },
  {
    "name": "WarmNeon",
    "isDark": true,
    "colors": {
      "background": "#3f3f3f",
      "surface": "#535353",
      "surfaceHover": "#686868",
      "surfaceElevated": "#5e5e5e",
      "text": "#c7f2ce",
      "textSecondary": "#fdfcfc",
      "textMuted": "#e6f2e7",
      "primary": "#819fff",
      "primaryHover": "#7a90d5",
      "primaryLight": "#7593f8",
      "primarySubtle": "#5e5e5e",
      "secondary": "#29bad3",
      "secondaryHover": "#5ed1e4",
      "accent": "#e24345",
      "accentHover": "#e86f71",
      "success": "#38b139",
      "border": "#7f7f7f",
      "borderSubtle": "#656565",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#3f3f3f",
      "#afdab6",
      "#e24345",
      "#38b139",
      "#dae145",
      "#4260c5",
      "#29bad3",
      "#fdfcfc"
    ],
    "id": "warmneon"
  },
  {
    "name": "Wez",
    "isDark": true,
    "colors": {
      "background": "#000000",
      "surface": "#141414",
      "surfaceHover": "#292929",
      "surfaceElevated": "#1f1f1f",
      "text": "#b3b3b3",
      "textSecondary": "#7f7f7f",
      "textMuted": "#747474",
      "primary": "#5455cb",
      "primaryHover": "#5555ff",
      "primaryLight": "#8788fe",
      "primarySubtle": "#1f1f1f",
      "secondary": "#7acaca",
      "secondaryHover": "#55ffff",
      "accent": "#cc5555",
      "accentHover": "#ff5555",
      "success": "#55cc55",
      "border": "#404040",
      "borderSubtle": "#262626",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#000000",
      "#b3b3b3",
      "#cc5555",
      "#55cc55",
      "#cdcd55",
      "#5455cb",
      "#7acaca",
      "#555555"
    ],
    "id": "wez"
  },
  {
    "name": "WildCherry",
    "isDark": true,
    "colors": {
      "background": "#1f1626",
      "surface": "#332a3a",
      "surfaceHover": "#483f4f",
      "surfaceElevated": "#3e3545",
      "text": "#d9faff",
      "textSecondary": "#06a2cf",
      "textMuted": "#41b8d9",
      "primary": "#994ded",
      "primaryHover": "#2f8bb9",
      "primaryLight": "#ba6eff",
      "primarySubtle": "#3e3545",
      "secondary": "#c1b8b6",
      "secondaryHover": "#ff919d",
      "accent": "#d94085",
      "accentHover": "#da6bab",
      "success": "#2ab250",
      "border": "#5f5666",
      "borderSubtle": "#453c4c",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#1f1626",
      "#d9faff",
      "#d94085",
      "#2ab250",
      "#ffd06e",
      "#873bdb",
      "#c1b8b6",
      "#009cc9"
    ],
    "id": "wildcherry"
  },
  {
    "name": "Wizzy Bright",
    "isDark": true,
    "colors": {
      "background": "#100814",
      "surface": "#241c28",
      "surfaceHover": "#39313d",
      "surfaceElevated": "#2f2733",
      "text": "#b2b8c4",
      "textSecondary": "#878787",
      "textMuted": "#838589",
      "primary": "#6c88a6",
      "primaryHover": "#7aade6",
      "primaryLight": "#9fbbd9",
      "primarySubtle": "#2f2733",
      "secondary": "#6498bf",
      "secondaryHover": "#82b8df",
      "accent": "#bf7998",
      "accentHover": "#cf7fb3",
      "success": "#5ba6a6",
      "border": "#504854",
      "borderSubtle": "#362e3a",
      "shadow": "rgba(0, 0, 0, 0.4)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#100814",
      "#b2b8c4",
      "#bf7998",
      "#5ba6a6",
      "#8d8daa",
      "#6c88a6",
      "#6498bf",
      "#6f6f6f"
    ],
    "id": "wizzy-bright"
  },
  {
    "name": "Yorumi Mist",
    "isDark": false,
    "colors": {
      "background": "#bdbfcb",
      "surface": "#b5b7c3",
      "surfaceHover": "#a9abb7",
      "surfaceElevated": "#b8bac6",
      "text": "#060914",
      "textSecondary": "#1d202b",
      "textMuted": "#161924",
      "primary": "#0d2c4e",
      "primaryHover": "#000628",
      "primaryLight": "#5a799b",
      "primarySubtle": "#b0b2be",
      "secondary": "#104351",
      "secondaryHover": "#001d2b",
      "accent": "#4e0e0e",
      "accentHover": "#280000",
      "success": "#1c4642",
      "border": "#9799a5",
      "borderSubtle": "#a9abb7",
      "shadow": "rgba(0, 0, 0, 0.08)",
      "textOnPrimary": "#ffffff"
    },
    "palette": [
      "#bdbfcb",
      "#060914",
      "#4e0e0e",
      "#1c4642",
      "#543407",
      "#0d2c4e",
      "#104351",
      "#1d202b"
    ],
    "id": "yorumi-mist"
  }
];
